/**
 * i18n/translations.js - Sistema de Traduções PT/EN
 * CG Business ERP
 */

export const translations = {
  pt: {
    // Menu Groups
    menu: {
      panel: 'PAINEL',
      operations: 'OPERAÇÕES',
      financial: 'FINANCEIRO',
      relations: 'RELAÇÕES',
      system: 'SISTEMA'
    },
    // Navigation Items
    nav: {
      dashboard: 'Painel Principal',
      financialAnalysis: 'Análise Financeira',
      riskManagement: 'Gestão de Risco',
      inventory: 'Inventário',
      sales: 'Vendas',
      services: 'Serviços',
      procurement: 'Compras',
      kits: 'Kits / Bundles',
      documents: 'Documentos',
      stockTransfers: 'Transferências de Stock',
      receivables: 'Contas a Receber',
      cash: 'Caixa',
      expenses: 'Despesas',
      payroll: 'Folha Salarial (RH)',
      pricing: 'Preços e Custos',
      clients: 'Clientes',
      licenses: 'Licenças',
      alerts: 'Alertas',
      catalogs: 'Catálogos',
      adminCenter: 'Centro Administrativo',
      users: 'Utilizadores',
      userManagement: 'Utilizadores',
      suppliers: 'Fornecedores',
      projects: 'Obras/Projectos',
      whatsapp: 'WhatsApp',
      reports: 'Relatórios',
      reportsModule: 'Relatórios Avançados',
      feedback: 'Feedback',
      integrity: 'Integridade',
      settings: 'Definições',
      templateBuilder: 'Template Builder',
      suppliers: 'Fornecedores',
      projects: 'Obras/Projectos',
      about: 'Sobre'
    },
    roles: {
      admin: 'Administrador',
      store_manager: 'Gerente',
      accountant: 'Contabilista',
      seller: 'Vendedor',
      technician: 'Técnico',
      staff: 'Staff',
      cashier: 'Caixa'
    },
    sidebar: {
      systemOnline: 'Sistema Online'
    },
    // Common Actions
    actions: {
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      restore: 'Restaurar',
      edit: 'Editar',
      create: 'Criar',
      search: 'Pesquisar',
      filter: 'Filtrar',
      export: 'Exportar',
      import: 'Importar',
      refresh: 'Actualizar',
      close: 'Fechar',
      confirm: 'Confirmar',
      back: 'Voltar',
      next: 'Seguinte',
      previous: 'Anterior',
      add: 'Adicionar',
      remove: 'Remover',
      view: 'Ver',
      download: 'Descarregar',
      upload: 'Carregar',
      print: 'Imprimir',
      send: 'Enviar',
      approve: 'Aprovar',
      reject: 'Rejeitar',
      submit: 'Submeter',
      logout: 'Sair'
    },
    // Common Labels
    labels: {
      name: 'Nome',
      email: 'Email',
      password: 'Palavra-passe',
      phone: 'Telefone',
      address: 'Morada',
      date: 'Data',
      time: 'Hora',
      status: 'Estado',
      type: 'Tipo',
      search: 'Pesquisar',
      category: 'Categoria',
      description: 'Descrição',
      notes: 'Notas',
      amount: 'Valor',
      total: 'Total',
      subtotal: 'Subtotal',
      quantity: 'Quantidade',
      price: 'Preço',
      cost: 'Custo',
      profit: 'Lucro',
      discount: 'Desconto',
      tax: 'Imposto',
      reference: 'Referência',
      number: 'Número',
      code: 'Código',
      datetime: 'Data/Hora',
      location: 'Localização',
      employee: 'Colaborador',
      client: 'Cliente',
      customer: 'Cliente',
      supplier: 'Fornecedor',
      product: 'Produto',
      service: 'Serviço',
      payment: 'Pagamento',
      all: 'Todos',
      none: 'Nenhum',
      yes: 'Sim',
      no: 'Não',
      active: 'Activo',
      inactive: 'Inactivo',
      pending: 'Pendente',
      completed: 'Concluído',
      cancelled: 'Cancelado',
      approved: 'Aprovado',
      rejected: 'Rejeitado'
    },
    // Periods
    periods: {
      allTime: 'Todo período',
      today: 'Hoje',
      yesterday: 'Ontem',
      thisWeek: 'Esta Semana',
      lastWeek: 'Semana Passada',
      thisMonth: 'Este Mês',
      lastMonth: 'Mês Passado',
      thisQuarter: 'Este Trimestre',
      thisYear: 'Este Ano',
      lastYear: 'Ano Passado',
      custom: 'Personalizado'
    },
    // Messages
    messages: {
      loading: 'A carregar...',
      saving: 'A guardar...',
      saved: 'Guardado com sucesso',
      deleted: 'Eliminado com sucesso',
      error: 'Ocorreu um erro',
      noData: 'Sem dados',
      noResults: 'Nenhum resultado encontrado',
      confirmDelete: 'Tem a certeza que deseja eliminar?',
      required: 'Campo obrigatório',
      invalidEmail: 'Email inválido',
      invalidPhone: 'Telefone inválido',
      success: 'Operação realizada com sucesso',
      logout: 'Sessão terminada'
    },
    // Dashboard
    dashboard: {
      title: 'Painel Principal',
      subtitle: 'Visão geral do negócio',
      totalRevenue: 'Receita Total',
      totalExpenses: 'Despesas Total',
      netProfit: 'Lucro Líquido',
      avgTicket: 'Ticket Médio',
      salesEvolution: 'Evolução de Vendas',
      expensesByCategory: 'Despesas por Categoria',
      topProducts: 'Top Produtos',
      topEmployees: 'Top Colaboradores',
      cashByLocation: 'Caixa por Localização',
      recentSales: 'Vendas Recentes',
      netResult: 'Resultado Líquido',
      cashDifference: 'Diferença Caixa',
      alerts: 'Alertas',
      previousPeriod: 'vs período anterior',
      salesCount: '{{count}} vendas',
      performanceOverTime: 'Performance ao longo do tempo',
      selectedPeriod: 'Período',
      salesLabel: 'Vendas',
      noSalesInPeriod: 'Sem dados de vendas no período',
      noExpensesInPeriod: 'Sem despesas no período',
      productsSold: '{{count}} vendidos',
      noTopEmployees: 'Sem dados de vendedores no período',
      quickActions: 'Acções Rápidas',
      newSale: 'Nova Venda',
      newQuotation: 'Nova Cotação',
      newClient: 'Novo Cliente',
      newService: 'Novo Serviço',
      inventory: 'Inventário',
      lowStockBadge: '{{count}} baixo',
      requiresAttention: 'Requer Atenção',
      waitingServices: 'Serviços em espera',
      pendingQuotations: 'Cotações pendentes',
      lowStock: 'Stock baixo',
      recentActivity: 'Actividade Recente',
      noRecentActivity: 'Sem actividades recentes',
      performanceScore: 'Score de Performance',
      points: 'pontos',
      excellentPerformance: 'Excelente performance!',
      keepGoing: 'Bom trabalho! Continue assim.',
      roomToImprove: 'Há espaço para melhorar!',
      topExpenses: 'Top 5 Despesas Mais Altas',
      viewAll: 'Ver todos',
      viewFullReport: 'Ver relatório completo',
      loadError: 'Erro ao carregar dashboard',
      refreshed: 'Dashboard actualizado!',
      accessRestricted: 'Acesso Restrito',
      accessRestrictedDescription: 'O Dashboard está disponível apenas para utilizadores autorizados.',
      greeting: 'Olá, {{name}}! Aqui está o resumo do seu negócio.',
      defaultUserName: 'Utilizador',
      live: 'Ao Vivo',
      allLocations: 'Todas Localizações',
      defaultLocationBadge: 'Loja padrão: {{location}}',
      loading: 'A carregar dashboard...',
      emptyStateTitle: 'Dashboard sem dados suficientes',
      emptyStateDescription: 'Ainda não existem indicadores, gráficos ou rankings suficientes para este período. Pode rever os relatórios completos ou carregar dados operacionais.',
      activityFeed: {
        title: '{{entity}}: {{action}}',
        unknownActor: 'Sistema',
        noDetails: 'Sem detalhes adicionais',
        entities: {
          sale: 'Venda',
          service: 'Serviço',
          client: 'Cliente',
          supplier: 'Fornecedor',
          user: 'Utilizador',
          stock: 'Stock',
          expense: 'Despesa',
          payment: 'Pagamento',
          document: 'Documento',
          settings: 'Configuração',
          generic: 'Actividade'
        },
        actions: {
          created: 'criado',
          updated: 'actualizado',
          edited: 'editado',
          deleted: 'eliminado',
          hard_deleted: 'apagado permanentemente',
          restored: 'restaurado',
          approved: 'aprovado',
          rejected: 'rejeitado',
          processed: 'processado',
          confirmed: 'confirmado',
          cancelled: 'cancelado',
          closed: 'fechado',
          completed: 'concluído',
          opened: 'aberto',
          registered: 'registado',
          paid: 'pago',
          bulk_updated: 'actualização em lote',
          stock_adjusted: 'stock ajustado',
          user_updated: 'utilizador actualizado',
          dossier_updated: 'dossier actualizado',
          language_preference_updated: 'idioma actualizado',
          welcome_tour_preference_updated: 'tour de boas-vindas actualizado',
          password_reset_completed_public: 'password redefinida',
          user_deleted: 'utilizador apagado',
          default: 'actualizado'
        }
      },
      activity: {
        newSaleTitle: 'Nova venda registada',
        newSaleDescription: 'Venda #2024-001 - Cliente particular',
        completedServiceTitle: 'Serviço concluído',
        completedServiceDescription: 'Reparação iPhone 13 - Ecrã',
        newClientTitle: 'Novo cliente',
        newClientDescription: 'Empresa ABC Lda registada',
        sentQuotationTitle: 'Cotação enviada',
        sentQuotationDescription: 'COT-2024-089 aguarda aprovação',
        lowStockTitle: 'Stock baixo',
        lowStockDescription: 'iPhone 15 Pro - Apenas 2 unidades',
        time2m: '2 min',
        time15m: '15 min',
        time30m: '30 min',
        time1h: '1h',
        time2h: '2h'
      }
    },
    login: {
      welcomeToast: 'Bem-vindo ao CG Business ERP!',
      invalidCredentials: 'Credenciais inválidas. Verifique o email e senha.',
      identifierLabel: 'Username ou email',
      identifierPlaceholder: 'username ou email@empresa.com',
      userNotFound: 'Username ou email não encontrado',
      wrongPassword: 'Password incorrecta',
      technicalError: 'Erro técnico ao iniciar sessão',
      systemLabel: 'Sistema de Gestão Empresarial',
      accessPanel: 'Faça login para aceder ao seu painel de controlo',
      signInTitle: 'Iniciar Sessão',
      signInDescription: 'Introduza as suas credenciais para aceder',
      showPassword: 'Ver',
      hidePassword: 'Ocultar',
      signingIn: 'A entrar...',
      signInButton: 'Entrar',
      headline: 'O ERP mais completo de Moçambique',
      subheadline: 'Gestão integrada de vendas, inventário, serviços, finanças e muito mais. Tudo numa única plataforma.',
      featurePosTitle: 'Ponto de Venda Avançado',
      featurePosDescription: 'IVA 16%, múltiplos pagamentos, impressão POS e facturas',
      featureInventoryTitle: 'Gestão de Inventário',
      featureInventoryDescription: '308+ produtos, controlo de stock por localização, IMEI/Série',
      featureCrmTitle: 'CRM Integrado',
      featureCrmDescription: '311+ clientes, histórico de compras, alertas automáticos',
      featureAnalyticsTitle: 'Análise em Tempo Real',
      featureAnalyticsDescription: 'Dashboard inteligente, KPIs, relatórios financeiros',
      modulesLabel: 'Módulos',
      vatLabel: 'IVA Moçambique',
      operationalLabel: 'Operacional',
      secureSsl: 'SSL Seguro',
      protectedData: 'Dados Protegidos',
      locationDialogTitle: 'Escolher loja padrão para documentos',
      locationDialogDescription: 'Por padrão, usamos a loja do seu cadastro. Pode alterar abaixo para esta sessão.',
      locationDialogLabel: 'Loja padrão dos documentos',
      locationDialogPlaceholder: 'Selecione uma loja',
      continueButton: 'Continuar',
      forgotPassword: 'Esqueceu a password?'
    },
    passwordReset: {
      dialogTitle: 'Recuperar password',
      dialogDescription: 'Introduza o seu email e enviaremos um link seguro para redefinir a password.',
      emailPlaceholder: 'seuemail@empresa.com',
      sendLink: 'Enviar link de recuperação',
      sendingLink: 'A enviar...',
      requestSuccess: 'Se o email existir no sistema, enviaremos um link de recuperação.',
      requestError: 'Não foi possível enviar o link de recuperação.',
      providerRestriction: 'O email de recuperação está bloqueado pelo Resend em modo de teste. Verifique um domínio no Resend para enviar links a outros utilizadores.',
      pageTitle: 'Definir nova password',
      pageDescription: 'Crie uma nova password para voltar a entrar na sua conta.',
      newPassword: 'Nova password',
      confirmPassword: 'Confirmar nova password',
      resetButton: 'Redefinir password',
      resetting: 'A redefinir...',
      success: 'Password redefinida com sucesso. Faça login com a nova password.',
      mismatch: 'As passwords não coincidem.',
      invalidLinkTitle: 'Link inválido ou expirado',
      invalidLinkDescription: 'Peça um novo email de recuperação para continuar.',
      backToLogin: 'Voltar ao login',
      requestAnother: 'Pedir novo link',
      validatedFor: 'Link válido para {{email}}',
      helper: 'Use pelo menos 8 caracteres para maior segurança.'
    },
    documents: {
      emptyTitle: 'Sem dados disponíveis',
      emptyDescription: 'Nenhum registo encontrado para Documentos Comerciais. Pode configurar ou importar dados para começar.',
      title: 'Documentos Comerciais',
      description: 'Cotações, guias de entrega e guias de recepção com leitura mais clara, operação mais rápida e métricas no topo da página.',
      badge: 'Comercial',
      quotationsLabel: 'Cotações',
      quotationsPendingHelper: '{{count}} pendentes',
      conversionRateLabel: 'Taxa de Conversão',
      conversionRateHelper: 'Cotações convertidas em documento fiscal',
      receptionGuidesLabel: 'Guias de Recepção',
      receptionGuidesHelper: 'Recepções registadas',
      deliveryGuidesLabel: 'Guias de Entrega',
      deliveryGuidesHelper: '{{count}} por assinar',
      tabQuotations: 'Cotações',
      tabReception: 'Guias de Recepção',
      tabDelivery: 'Guias de Entrega',
      tabInvoices: 'Facturas',
      tabCreditNotes: 'Notas de Crédito',
      searchPlaceholder: 'Pesquisar documento, cliente ou código',
      locationPlaceholder: 'Filtrar por localização',
      allLocations: 'Todas localizações',
      openReceivables: 'Abrir Contas a Receber',
      bulkCancel: 'Cancelar ({{count}})',
      bulkRestoreDraft: 'Restaurar p/ Rascunho',
      exportSelected: 'Exportar',
      newQuotation: 'Nova Cotação',
      newClient: 'Novo Cliente',
      selectClient: 'Seleccionar Cliente',
      itemsAvailable: 'Itens ({{count}} produtos disponíveis)',
      addItem: 'Adicionar Item',
      addItemsHint: 'Adicione itens à cotação',
      vatRegime: 'Regime IVA:',
      vatIncluded: 'IVA Incluído',
      vatExcluded: 'IVA Excluído',
      exempt: 'Isento',
      rate: 'Taxa',
      subtotal: 'Subtotal',
      discounts: 'Descontos',
      taxableBase: 'Base Tributável',
      vat: 'IVA',
      total: 'Total',
      validity: 'Validade',
      location: 'Localização',
      selectPlaceholder: 'Seleccionar...',
      additionalNotesPlaceholder: 'Notas adicionais...',
      createQuotation: 'Criar Cotação',
      noQuotations: 'Nenhuma cotação encontrada',
      noReceptionGuides: 'Nenhuma guia de recepção encontrada',
      noDeliveryGuides: 'Nenhuma guia de entrega encontrada',
      noServiceInvoices: 'Nenhuma factura de serviço encontrada',
      signed: 'Assinado',
      pending: 'Pendente',
      invoice: 'Factura',
      service: 'Serviço',
      items: 'Artigos',
      convertQuotationTitle: 'Converter Cotação para Venda',
      documentType: 'Tipo Documental',
      selectDocumentType: 'Seleccionar tipo',
      selectLocation: 'Seleccionar localização',
      noItemsToConvert: 'Sem itens para converter',
      productDescription: 'Produto/Descrição',
      selectProduct: 'Seleccionar produto...',
      itemDescriptionPlaceholder: 'Descrição do artigo',
      price: 'Preço',
      totalPreview: 'Prévia total (sem alterar histórico da cotação)',
      creditNotes: {
        title: 'Notas de Crédito',
        description: 'Acompanhe devoluções, anulações e reposição de stock com filtros rápidos por estado, origem, reembolso e localização.',
        newButton: 'Emitir Nota de Crédito',
        refreshButton: 'Actualizar lista',
        empty: 'Nenhuma nota de crédito emitida',
        filteredEmpty: 'Nenhuma nota de crédito corresponde aos filtros actuais',
        emptyHint: 'Use uma venda ou factura de serviço como origem para emitir a primeira nota com rastreio completo.',
        filters: {
          status: 'Estado',
          refundMethod: 'Reembolso',
          origin: 'Origem',
          location: 'Localização',
          allStatuses: 'Todos os estados',
          allRefundMethods: 'Todos os reembolsos',
          allOrigins: 'Todas as origens',
          clear: 'Limpar filtros'
        },
        summary: {
          total: '{{count}} no total',
          pending: '{{count}} pendentes',
          approved: '{{count}} aprovadas',
          processed: '{{count}} processadas',
          pendingActions: '{{count}} por acção',
          totalAmount: '{{amount}} em notas visíveis'
        },
        quickFilters: {
          pending: 'Pendentes',
          approved: 'Aprovadas',
          customerCredit: 'Crédito cliente',
          saleOrigin: 'Origem venda',
          serviceOrigin: 'Origem serviço',
          clear: 'Limpar filtros'
        },
        activeFiltersLabel: 'Filtros activos',
        visibleResults: '{{count}} visíveis',
        columns: {
          number: 'Nº NC',
          originalDocument: 'Documento Original',
          origin: 'Origem',
          customer: 'Cliente',
          reason: 'Motivo',
          amount: 'Valor',
          refund: 'Reembolso',
          status: 'Estado',
          actions: 'Acções'
        },
        sourceTypes: {
          sale: 'Venda',
          service_invoice: 'Factura de Serviço'
        },
        refundMethods: {
          credit: 'Crédito ao Cliente',
          cash: 'Numerário',
          bank_transfer: 'Transferência Bancária',
          replacement: 'Substituição'
        },
        statuses: {
          pending: 'Pendente',
          approved: 'Aprovada',
          processed: 'Processada',
          rejected: 'Rejeitada',
          cancelled: 'Cancelada'
        },
        actions: {
          approve: 'Aprovar',
          process: 'Processar',
          pdf: 'PDF'
        },
        nextSteps: {
          approve: 'Próxima acção: aprovar',
          process: 'Próxima acção: processar',
          done: 'Concluída',
          review: 'Sem acção pendente'
        }
      }
    },
    migration: {
      title: 'Migração da Base Activa',
      description: 'Exportação e importação simplificadas para a arquitectura de base única. Toda a operação desta aba usa a base activa do sistema como referência principal.',
      primaryDb: 'Base principal',
      relatedDbs: 'Bases relacionadas',
      activePermissions: 'Permissões activas',
      activeDatabase: 'Base activa do sistema',
      activeDatabaseDescription: 'Este é o destino padrão usado pelo ERP e por todas as operações desta aba.',
      architectureLabel: 'Arquitectura actual',
      singleDatabaseBadge: 'Base única activa',
      singleDatabaseDescription: 'A terminologia antiga multi-base foi removida desta interface. Exportações e importações passam sempre pelo mesmo contexto activo.',
      collectionsCount: '{{count}} coleções detectadas',
      permissionsExport: 'exportação',
      permissionsImport: 'importação',
      exportCardTitle: 'Exportar pacote da base activa',
      exportCardDescription: 'Gera um pacote ZIP único da base activa com manifest e resumo, pronto para backup, auditoria ou migração controlada.',
      exportContextLabel: 'Contexto do pacote',
      exportContextDescription: 'O pacote é sempre gerado a partir da base activa do sistema. Não existe mais escolha entre bases primária/relacionadas na UI.',
      scope: 'Escopo',
      exportPrimaryOnly: 'Só base principal',
      exportAll: 'Todas as bases relevantes',
      generateExport: 'Gerar ZIP de Exportação',
      importCardTitle: 'Importar para a base activa',
      importCardDescription: 'Aceita ZIP completo ou múltiplos JSON e aplica-os ao contexto activo do sistema, sem expor opções antigas de multi-base.',
      importContextTitle: 'Como esta importação funciona',
      importContextPrimary: 'Destino único: base activa do sistema.',
      importContextSecondary: 'Se carregar JSON soltos, o módulo assume automaticamente o mesmo contexto lógico da base activa.',
      importContextDescription: 'O backend continua a receber o nome da base activa, mas a escolha já não é exposta ao utilizador.',
      targetDb: 'Base de destino',
      sourceDb: 'Base fonte (JSON soltos)',
      files: 'Ficheiros ZIP/JSON',
      filesSelected: '{{count}} ficheiro(s) seleccionado(s)',
      collectionsToImport: 'Coleções a importar',
      collectionsToImportHelp: 'Se nada for marcado, o backend usará todas as coleções disponíveis do pacote.',
      clearWarning: '`clear` é manual e fica desligado por defeito. Só active quando tiver certeza absoluta da coleção a limpar.',
      dryRun: 'Dry-run',
      importNow: 'Importar agora',
      refreshSummary: 'Actualizar resumo',
      latestOperation: 'Resumo da última operação',
      latestOperationDescription: 'Mostra a última importação/dry-run executada sobre a base activa, incluindo a validação pós-import quando existir.',
      historyTitle: 'Histórico de migração',
      historyDescription: 'Acompanhe exportações/importações da base activa e descarregue o relatório JSON de cada execução.',
      downloadReport: 'Descarregar relatório',
      noHistory: 'Ainda não existem operações registadas.',
      performedBy: 'Executado por',
      sourceDbLabel: 'Contexto lógico',
      targetDbLabel: 'Base activa',
      selectedCollections: 'Coleções seleccionadas',
      clearCollections: 'Coleções limpas',
      exportSuccess: 'Pacote de exportação gerado com sucesso',
      exportError: 'Erro ao exportar pacote de dados',
      importSuccess: 'Importação concluída',
      dryRunSuccess: 'Dry-run concluído',
      importError: 'Erro ao importar dados',
      dryRunError: 'Erro no dry-run',
      summaryError: 'Erro ao carregar resumo de migração',
      historyError: 'Erro ao carregar histórico de migração',
      reportError: 'Erro ao descarregar relatório',
      reportSuccess: 'Relatório descarregado com sucesso',
      read: 'Lidos',
      inserted: 'Inseridos',
      updated: 'Actualizados',
      ignored: 'Ignorados',
      errors: 'Erros',
      searchPlaceholder: 'Pesquisar por utilizador, pacote ou ficheiro',
      filterAllOperations: 'Todas as operações',
      noFilteredHistory: 'Nenhuma operação corresponde aos filtros actuais.',
      exportType: 'Exportação',
      importType: 'Importação',
      dryRunType: 'Dry-run',
      validationVerifiable: 'Verificáveis',
      validationMatched: 'Correspondentes',
      validationMissing: 'Em falta',
      validationUnverifiable: 'Não verificáveis'
    },
    financialAnalysis: {
      title: 'Análise Financeira',
      description: 'Layout alinhado ao cockpit técnico: leitura executiva do lucro operacional, reconciliação de custos reais, despesas/encargos e saúde do stock no mesmo painel.',
      badge: 'Custos + despesas',
      emptyTitle: 'Sem dados disponíveis',
      emptyDescription: 'Nenhum registo financeiro foi encontrado nesta base. Pode configurar/importar dados para desbloquear a análise financeira.',
      profitCompliance: 'Conformidade do lucro',
      profitComplianceDescription: 'O lucro principal desta página passa a usar como referência operacional a vista por loja, que já considera custos reais e despesas/encargos registados.',
      expensesAndCharges: 'Despesas & encargos',
      operatingMargin: 'Margem operacional',
      status: 'Estado',
      expectedProfit: 'Lucro dentro do esperado',
      negativeProfit: 'Lucro negativo — rever custos/despesas',
      totalRevenue: 'Receita Total',
      totalCostExpenses: 'Custos + Despesas',
      operationalProfit: 'Lucro Operacional',
      staleStock: 'Stock Parado',
      productsCount: '{{count}} produtos',
      tiedCapital: 'Capital Imobilizado',
      unitsCount: '{{count}} unidades',
      detailedIndicators: 'Indicadores detalhados',
      detailedIndicatorsDescription: 'Mais detalhe para leitura executiva: margem bruta, margem líquida, ticket médio, peso das despesas e mix de receita no período filtrado.',
      grossMargin: 'Margem bruta',
      netMargin: 'Margem líquida',
      averageTicket: 'Ticket médio',
      expenseWeight: 'Peso das despesas',
      consideredMoves: '{{count}} movimentos considerados',
      quickComparisons: 'Comparativos rápidos',
      quickComparisonsDescription: 'Variação face ao período anterior e leitura do sinal de rentabilidade.',
      revenue: 'Receita',
      netProfit: 'Lucro líquido',
      expenses: 'Despesas',
      signal: 'Sinal',
      serviceMix: 'Mix serviços',
      salesMix: 'Mix vendas',
      monthlyTrend: 'Tendência mensal',
      monthlyTrendDescription: 'Evolução dos últimos 6 meses para receita e lucro líquido, com melhor e pior mês destacados.',
      bestMonth: 'Melhor mês',
      watchMonth: 'Mês a vigiar',
      noData: 'Sem dados',
      netMarginShort: 'Margem líquida',
      profitTab: 'Lucro Operacional',
      allocationTab: 'Alocação',
      employeesTab: 'Por Colaborador',
      locationsTab: 'Por Loja',
      marginsTab: 'Margens',
      suppliersTab: 'Fornecedores',
      stockTab: 'Rotação Stock',
      moduleCommercial: 'Vendas / Comercial',
      moduleProjects: 'Obras / Projectos',
      moduleRepairs: 'Serviços Técnicos',
      moduleKits: 'Kits / Bundles',
      moduleGaming: 'Gaming Center',
      modulePapelaria: 'Papelaria',
      signalHealthy: 'Saudável',
      signalWarning: 'Atenção',
      signalCritical: 'Crítico',
      profitByServiceTitle: 'Lucro por tipo de serviço',
      serviceRevenue: 'Receita',
      partsCost: 'Custo Peças',
      sessionsCount: '{{count}} sessões',
      ordersCount: '{{count}} ordens',
      simpleMargin: 'Margem: {{value}}%',
      profitByProductTitle: 'Lucro por produto (Top 10)',
      topProductsSummary: 'Receita: {{revenue}} | Custo: {{cost}} | Lucro: {{profit}}',
      partialReportTitle: 'Relatório parcial: custos incompletos',
      partialReportFallback: 'Existem itens com custo parcial/inexistente',
      noSalesInFilteredPeriod: 'Sem vendas no período',
      soldCount: '{{count}} vendidos',
      marginUnavailable: 'Margem indisponível',
      marginValue: '{{value}}% margem',
      allocationTitle: 'Alocação por módulo / categoria',
      allocationDescription: 'Receita, custo directo, despesas alocadas e lucro operacional por vertical do ERP. A regra actual combina despesa directa por categoria e rateio proporcional à receita.',
      directCost: 'Custo directo',
      allocatedExpenses: 'Despesas alocadas',
      operationalProfitLabel: 'Lucro operacional',
      operationalMarginValue: 'Operacional {{value}}%',
      inventoryModule: 'Inventário / Stock',
      capitalLabel: 'Capital empatado',
      staleStockItems: 'Stock sem venda',
      riskValue: 'Valor de risco',
      alertsLabel: 'Alertas',
      itemsLabel: '{{count}} itens',
      expenseAllocationTitle: 'Despesas alocadas por categoria',
      noAllocationRule: 'Sem regra disponível.',
      allocatedTotalsTitle: 'Totais alocados',
      totalRevenueLabel: 'Receita total',
      totalCostLabel: 'Custo total',
      grossProfitLabel: 'Lucro bruto',
      employeesPerformanceTitle: 'Performance por colaborador',
      employeesPerformanceSummary: 'Total: {{profit}} lucro | {{sales}} vendas | {{services}} serviços',
      noActivityInPeriod: 'Nenhuma actividade no período',
      salesAndServicesCount: '{{sales}} vendas • {{services}} serviços',
      salesRevenue: 'Vendas: {{value}}',
      servicesRevenue: 'Serviços: {{value}}',
      performanceAnalysisTitle: 'Análise de Performance:',
      bestPerformerLabel: 'Melhor:',
      performanceGapLabel: 'Gap de performance:',
      storePerformanceTitle: 'Performance por loja',
      drainingLocations: 'Lojas a drenar caixa: {{locations}}',
      noStoresFound: 'Nenhuma loja encontrada',
      salesShort: 'Vendas',
      servicesShort: 'Serviços',
      expensesShort: 'Despesas',
      expectedVsActualMarginTitle: 'Margem esperada vs real',
      gapSummary: 'Gap: {{amount}} ({{percent}}%)',
      reportInfoTitle: 'Informações do relatório',
      minimumRequiredMarginLabel: 'Margem mínima obrigatória',
      minimumRequiredMarginHint: 'Pode alterar aqui na UI. Valor guardado também em `localStorage` (`financial-analysis-minimum-margin-pct`).',
      expectedProfitLabel: 'Lucro Esperado',
      realProfitLabel: 'Lucro Real',
      differenceLabel: 'Diferença',
      currentMinimumMargin: 'Margem mínima obrigatória actual: {{value}}%',
      underperformingProducts: '{{count}} produtos com margem abaixo do esperado',
      productsMarginDeviation: 'Produtos com desvio de margem:',
      expectedLabel: 'Esperado: {{value}}%',
      actualLabel: 'Real: {{value}}%',
      deviationLabel: '{{value}}% desvio',
      supplierComparisonTitle: 'Comparação de fornecedores',
      supplierComparisonDescription: 'Ordenados por valor total de compras',
      noSuppliersFound: 'Nenhum fornecedor encontrado',
      ordersAndProductsCount: '{{orders}} encomendas • {{products}} produtos',
      averageOrderValue: 'Média: {{value}}',
      stockAlertsTitle: 'Alertas de Stock ({{count}})',
      criticalCount: 'Críticos: {{count}}',
      highCount: 'Altos: {{count}}',
      mediumCount: 'Médios: {{count}}',
      highRotationTitle: 'Alta Rotação ({{count}})',
      highRotationDescription: 'Produtos com rotação ≥ 2x',
      noProductsLabel: 'Nenhum produto',
      lowRotationTitle: 'Baixa Rotação ({{count}})',
      lowRotationDescription: 'Produtos com rotação < 0.5x',
      stockShort: 'Stock: {{count}}',
      staleProductsTitle: 'Produtos Sem Saída (30+ dias)',
      staleProductsDescription: '{{count}} produtos | Valor parado: {{value}}',
      noStaleProducts: 'Nenhum produto parado',
      lastSaleLabel: 'Última venda: {{value}}',
      neverSold: 'Nunca vendido',
      daysAgo: '{{count}} dias',
      recommendationsTitle: 'Recomendações:',
      partialPanelsToast: 'Alguns painéis da Análise Financeira vieram vazios ou indisponíveis, mas a página foi aberta com dados parciais.',
      loadError: 'Erro ao carregar dados financeiros'
    },
    gamingCenter: {
      title: 'Gaming Center',
      description: 'Visual alinhado ao cockpit técnico: sessões activas, receita diária, ocupação de consolas e próximos passos operacionais num único topo executivo.',
      badge: 'Experiência Gaming',
      activeSessions: 'Sessões activas',
      activeNow: 'Em curso agora',
      sessionsToday: 'Sessões hoje',
      dailyService: 'Atendimento diário',
      revenueToday: 'Receita hoje',
      operatingRevenue: 'Receita operacional',
      freeConsoles: 'Consolas livres',
      configuredCount: '{{count}} configuradas',
      configure: 'Configurar',
      refresh: 'Actualizar',
      loadingError: 'Erro ao carregar dados do Gaming Center',
      partialConsolesError: 'Alguns dados do Gaming Center falharam, mas a página foi aberta com fallback parcial.',
      emptyTitle: 'Sem dados de gaming disponíveis',
      emptyDescription: 'Adicione localizações, métodos de pagamento ou serviços de gaming para começar a operar este módulo.',
      activeSessionsCard: 'Sessões Activas',
      location: 'Localização',
      employee: 'Colaborador',
      selectPlaceholder: 'Seleccionar',
      latestSession: 'Última Sessão Criada',
      start: 'INÍCIO',
      end: 'FIM',
      duration: 'DURAÇÃO',
      paymentMethod: 'FORMA DE PAGAMENTO',
      printOriginal: 'Imprimir POS (Original)',
      printDuplicate: 'Imprimir POS (Duplicado)',
      viewInSales: 'Ver em Vendas',
      consolesOccupancy: 'Consolas ({{busy}}/{{total}} ocupadas)',
      reload: 'Recarregar',
      consoleLabel: 'Consola {{number}}',
      inUse: 'Em Uso',
      stop: 'Parar',
      available: 'Livre',
      clickToStart: 'Clique para iniciar',
      startSession: 'Iniciar',
      recentSessions: 'Sessões de Hoje',
      noSessionsToday: 'Nenhuma sessão registada hoje'
    },
    salesPage: {
      title: 'Ponto de Venda',
      description: 'Operação de caixa, vendas recentes e controlo rápido de pagamentos num topo mais claro e alinhado com o restante ERP.',
      recentSales: 'Vendas Recentes',
      filteredPeriodRecords: 'Registos do período filtrado',
      totalSold: 'Total Vendido',
      aggregatedAmount: 'Montante agregado do período',
      cancelled: 'Canceladas',
      cancelledHelper: 'Vendas anuladas',
      cart: 'Carrinho',
      cartHelper: 'Itens na venda em curso',
      cancelSelected: 'Cancelar ({{count}})',
      restoreDraft: 'Restaurar p/ Rascunho',
      export: 'Exportar',
      newSale: 'Nova Venda',
      salesTab: 'Vendas',
      cashTab: 'Caixa Integrado',
      cancelledTab: 'Vendas Canceladas',
      recentSalesTitle: 'Vendas Recentes ({{count}})',
      loadingSales: 'A carregar vendas...',
      noSales: 'Sem vendas registadas',
      cashOperationalLocation: 'Localização Operacional POS/Caixa',
      activeLocation: 'Localização activa',
      selectLocation: 'Seleccione a localização',
      cancelledSalesTitle: 'Vendas Canceladas ({{count}})',
      deleteCancelled: 'Eliminar Canceladas',
      noCancelledSales: 'Sem vendas canceladas',
      details: 'Detalhes',
      printCancelled: 'Imprimir Anulado',
      delete: 'Eliminar',
      posDialogTitle: 'Nova Venda',
      posDialogDescription: 'Seleccione a localização e adicione produtos ao carrinho',
      locationLabel: 'Localização:',
      selectStoreLocation: 'Seleccione a loja/local',
      sellingAt: 'Vendendo em: {{location}}',
      searchProduct: 'Pesquisar produto...',
      selectLocationFirst: 'Seleccione uma localização primeiro',
      searchProductPlaceholder: 'Nome, SKU, marca...',
      loadingProducts: 'A carregar produtos...',
      noProductsFound: 'Nenhum produto encontrado',
      availableProducts: 'Produtos Disponíveis',
      includesComponents: 'Inclui {{count}} componentes',
      availableItemsAt: 'Itens disponíveis em:',
      noStockAtLocation: 'Sem stock em {{location}}',
      emptyCart: 'Carrinho vazio',
      employeeForSale: 'Colaborador que efectuou a venda *',
      selectEmployee: 'Seleccionar colaborador',
      clientLabel: 'Cliente *',
      searchClient: 'Pesquisar cliente...',
      clientSearchPlaceholder: 'Nome, NUIT, código...',
      noClientFound: 'Nenhum cliente encontrado.',
      createClient: 'Criar Cliente',
      indifferentClient: 'Cliente Indiferenciado',
      foundClients: 'Clientes encontrados',
      quickClient: 'Cliente Rápido',
      company: 'Empresa',
      individual: 'Particular',
      saleDiscount: 'Desconto na Venda',
      amountMt: 'Valor (MT)',
      paymentMethod: 'Forma de Pagamento *',
      selectAccount: 'Seleccionar conta',
      paid: 'Pago',
      exactPaymentHint: 'Métodos não numerário não geram troco; pode combiná-los com Numerário.',
      mixedPaymentCashHint: 'O troco é calculado apenas sobre a componente em Numerário.',
      fillRemaining: 'Preencher restante ({{amount}})',
      optionalNotes: 'Notas opcionais...',
      registeredAt: 'Data/Hora do Registo (opcional)',
      createDraft: 'Criar como rascunho',
      vatRegime: 'Regime IVA',
      vatIncluded: 'IVA Incluído',
      vatExcluded: 'IVA Excluído',
      exempt: 'Isento',
      vatRateInfo: 'Taxa: {{rate}}% | {{mode}}',
      priceIncludesVat: 'Preço já inclui IVA',
      vatWillBeAdded: 'IVA será adicionado',
      noVat: 'Sem IVA',
      subtotalGross: 'Subtotal Bruto',
      itemDiscountShort: 'Desc. Items',
      saleDiscountShort: 'Desc. Venda',
      taxableBase: 'Base Tributável',
      totalUpper: 'TOTAL',
      totalCostPreview: 'Custo Total (preview)',
      totalProfitPreview: 'Lucro Total (preview)',
      totalMarginPreview: 'Margem Total (preview)',
      unreliableMargin: 'Margem não confiável',
      unreliableMarginHint: 'Custo inexistente/incompleto - rever compras/receções',
      paidUpper: 'PAGO',
      nonCashPaid: 'Pago sem Numerário',
      cashPaid: 'Pago em Numerário',
      changeUpper: 'TROCO',
      remaining: 'Falta',
      nonCashOverflow: 'Excesso sem Numerário',
      differenceShouldBeZero: 'Diferença (deve ser 0)',
      noOpenCash: 'Sem sessão de caixa aberta em {{location}}. Não é possível confirmar venda.',
      openCashNow: 'Abrir Caixa Integrado Agora',
      processing: 'A processar...',
      saveDraft: 'Guardar Rascunho',
      finalizeSale: 'Finalizar Venda',
      cancelledDocument: 'Documento',
      cancelledDatetime: 'Data/Hora',
      cancelledBy: 'Cancelada por',
      cancelledReason: 'Motivo',
      cancelledStock: 'Stock',
      actions: 'Acções',
      stockReturned: 'Devolvido',
      stockNotReturned: 'Não devolvido',
      lossSale: 'Venda com prejuízo',
      belowMarginSale: 'Estás a vender abaixo do mínimo',
      negativeProfitConfirmation: 'Confirmação reforçada: venda com lucro negativo.',
      belowMarginConfirmation: 'Confirmação obrigatória para finalizar a venda abaixo da margem mínima.',
      marginLabel: 'Margem',
      minimumShort: 'mín.',
      salePrice: 'Preço de venda',
      minimumPrice: 'Preço mínimo',
      difference: 'Diferença',
      profit: 'Lucro',
      quantity: 'Quantidade',
      lineTotal: 'Total da linha',
      supervisorApprovalRequired: 'Requer aprovação de supervisor/gestor. Insira PIN para autorizar.',
      authorizerName: 'Nome do autorizador *',
      selectAuthorizer: 'Seleccione o autorizador',
      loadingAuthorizers: 'A carregar autorizadores...',
      authorizerRequired: 'Seleccione o utilizador que vai autorizar a venda.',
      authorizerInvalid: 'O utilizador seleccionado já não pode autorizar esta venda.',
      authorizerPinNotConfigured: 'O utilizador seleccionado não tem PIN configurado.',
      authorizerRolesHelp: 'Perfis autorizados: Supervisor, Gerente e Administrador.',
      authorizerSelectedHelp: 'A autorização ficará registada em nome de {{name}}.',
      noCommercialAuthorizersConfigured: 'Não existe nenhum utilizador autorizado com PIN configurado neste momento.',
      commercialPinRequired: 'PIN comercial obrigatório.',
      invalidCommercialPin: 'PIN inválido.',
      commercialPinRateLimit: 'Demasiadas tentativas de PIN. Tente novamente mais tarde.',
      saleAuthorizedBy: 'Venda autorizada por {{name}}.',
      lossSaleStrong: 'Venda com prejuízo.',
      reinforcedConfirmationRequired: 'Confirmação reforçada obrigatória.',
      supervisorPin: 'PIN de Supervisor *',
      enterPin: 'Introduza o PIN',
      understandLoss: 'Compreendo o prejuízo',
      overrideReason: 'Motivo do override *',
      describeOverrideReason: 'Descreva o motivo do override',
      goBackAdjust: 'Voltar e ajustar',
      finalizeAnyway: 'Finalizar mesmo assim',
      insufficientStock: 'Stock insuficiente',
      lossConfirmationRequired: 'Confirmação de prejuízo obrigatória',
      overrideReasonRequired: 'Motivo do override obrigatório (mínimo 5 caracteres)',
      printDocumentOpened: 'Documento aberto para impressão',
      printCancelledOpened: 'Documento ANULADO aberto para impressão',
      adminCancelled: 'Venda cancelada pelo administrador!',
      adminCancelledStock: 'Venda cancelada pelo administrador - Stock devolvido!',
      saleCancelled: 'Venda cancelada!',
      saleCancelledStock: 'Venda cancelada - Stock devolvido!',
      cancellationReasonRequired: 'Motivo de cancelamento é obrigatório',
      selectLocationBeforeScan: 'Seleccione uma localização antes de escanear',
      saleFromQuote: 'Venda originada da cotação {{reference}}',
      saleFromProject: 'Venda originada da obra {{reference}}',
      purgedCancelledSales: 'Vendas canceladas eliminadas ({{count}})',
      selectLocationFirstShort: 'Seleccione uma localização primeiro',
      selectLocationBeforeProducts: 'Seleccione uma localização antes de adicionar produtos',
      selectAccountAndAmount: 'Seleccione a conta e informe o valor',
      selectLocationForSale: 'Seleccione uma localização para a venda',
      selectEmployeeForSale: 'Seleccione o colaborador que efectuou a venda',
      selectClientForSale: 'Seleccione um cliente, crie um cliente ou use Cliente Indiferenciado',
      employeeNotFound: 'Colaborador não encontrado',
      draftCreated: 'Rascunho de venda criado!',
      saleCompletedAt: 'Venda realizada em {{location}}!',
      updateCompleted: 'Venda actualizada!',
      saleAlreadyCancelled: 'Venda já está cancelada',
      saleConfirmed: 'Venda confirmada!',
      saleMarkedPaid: 'Venda marcada como paga!',
      saleConcluded: 'Venda concluída!',
      selectSalesBulkAction: 'Seleccione vendas para ação em massa',
      selectSalesExport: 'Seleccione vendas para exportar',
      saleNumber: 'Nº Venda',
      employeeShort: 'Colaborador',
      statusShort: 'Estado',
      statusLabel: 'Estado',
      locationShort: 'Localização',
      customerCode: 'Código',
      openReceivable: 'Ver Conta a Receber',
      originatedQuote: 'Originado da Cotação:',
      originatedProject: 'Originado da Obra:',
      itemsSection: 'Items',
      productLabel: 'Produto',
      qtyLabelShort: 'Qtd',
      priceLabel: 'Preço',
      discountLabelShort: 'Desc.',
      costLabel: 'Custo',
      profitLabelShort: 'Lucro',
      marginLabelShort: 'Margem',
      paymentSection: 'Forma de Pagamento',
      paymentFormLine: 'Forma de Pagamento:',
      subtotal: 'Subtotal',
      itemsDiscount: 'Desconto Items',
      saleDiscountWithPct: 'Desconto Venda ({{pct}}%)',
      totalCost: 'Custo Total',
      totalProfit: 'Lucro Total',
      totalMargin: 'Margem Total',
      printOptions: 'Opções de Impressão',
      printCancelledDocument: 'Imprimir Documento ANULADO',
      invoice: 'Factura',
      deliveryGuide: 'Guia',
      newClientTitle: 'Novo Cliente',
      newClientDescription: 'Crie um cliente e associe automaticamente à venda.',
      nameRequired: 'Nome *',
      taxId: 'NUIT',
      typeLabel: 'Tipo',
      addressLabel: 'Morada',
      cityLabel: 'Cidade',
      contactPerson: 'Pessoa de Contacto',
      creating: 'A criar...',
      editSaleTitle: 'Editar Venda - {{sale}}',
      changesTracked: 'Alterações ficam registadas no histórico.',
      customerNameLabel: 'Nome do Cliente',
      customerBlockTitle: 'Cliente e identificação',
      customerBlockDescription: 'Actualize os dados comerciais ligados à venda.',
      editableProjectValues: 'Valores editáveis da venda gerada da obra',
      editableProjectValuesDesc: 'Pode ajustar apenas quantidades, preços e descontos das linhas desta venda draft.',
      editSaleFullAccess: 'Admin/Gerente pode rever linhas, pagamentos, descontos e dados do cliente numa única edição.',
      editSaleItemsTitle: 'Linhas da venda',
      editSaleItemsDescription: 'Edite quantidades, preços, descontos, descrição e IVA sem sair da venda.',
      editSaleFinancialTitle: 'Dados financeiros',
      editSaleFinancialDescription: 'Reveja colaborador, descontos globais e totais recalculados em tempo real.',
      editSalePaymentsDescription: 'Ajuste a composição dos pagamentos para manter a venda coerente com o novo total.',
      editSaleComputedTotal: 'Novo total',
      addPaymentLabel: 'Adicionar',
      noAdditionalDescription: 'Sem descrição adicional',
      valueDiscount: 'Desconto valor',
      percentDiscount: 'Desconto %',
      justificationRequiredLabel: 'Justificação *',
      changeReasonPlaceholder: 'Motivo da alteração...',
      save: 'Guardar',
      purgeCancelledTitle: 'Eliminar vendas canceladas',
      purgeOneDescription: 'Esta acção remove permanentemente a venda cancelada {{sale}} e todos os registos ligados.',
      purgeAllDescription: 'Esta acção remove permanentemente todas as vendas canceladas e todos os registos ligados.',
      deleting: 'A eliminar...',
      confirmDelete: 'Confirmar eliminação',
      confirmChangeTitle: 'Confirmar Alteração',
      changeWillBeTracked: 'Esta alteração ficará registada no histórico.',
      cancelSaleTitle: 'Cancelar Venda',
      returnItemsToStock: 'Devolver items ao stock',
      additionalNotes: 'Notas adicionais',
      cancellationReasonPlaceholder: 'Motivo do cancelamento...',
      additionalNotesPlaceholder: 'Notas opcionais sobre o cancelamento',
      back: 'Voltar',
      historyTitle: 'Histórico - {{sale}}',
      noRecords: 'Sem registos',
      createdStatus: 'Criação',
      editedStatus: 'Edição',
      confirmedStatus: 'Confirmação',
      paidStatus: 'Pagamento',
      completedStatus: 'Conclusão',
      cancelledStatus: 'Cancelamento',
      reasonLabel: 'Motivo:',
      justificationLabel: 'Justificação:',
      emptyTitle: 'Sem dados de vendas disponíveis',
      emptyDescription: 'Configure localizações, contas de pagamento e produtos para começar a operar o POS.',
      partialData: 'Alguns blocos de vendas vieram com fallback parcial, mas o POS foi carregado com os dados disponíveis.',
      loadError: 'Erro ao carregar dados de vendas'
    },
    moduleState: {
      partialTitle: 'Dados carregados com fallback parcial',
      partialDescription: 'Algumas chamadas opcionais falharam, mas o módulo abriu e agora mostra exactamente o que ficou indisponível.',
      blockingTitle: 'Falhas críticas detectadas no carregamento',
      blockingDescription: 'Um ou mais endpoints obrigatórios falharam. O módulo já não esconde a causa real do problema.',
      issueTimeout: 'timeout da API',
      issueHttp: 'HTTP {{status}}',
      issueCritical: 'falha crítica',
      issueFallback: 'fallback activado',
      unknownEndpoint: 'endpoint desconhecido',
      moreIssues: '+{{count}} falha(s) adicional(is)'
    },
    // Alerts
    alerts: {
      title: 'Central de Alertas',
      subtitle: 'Gestão centralizada de todos os alertas',
      overview: 'Visão Geral',
      followups: 'Follow-ups',
      debtors: 'Devedores',
      fixedPayments: 'Pagamentos Fixos',
      pettyCash: 'Fundo de Caixa',
      suppliers: 'Fornecedores',
      warranties: 'Garantias',
      licenses: 'Licenças',
      allAlerts: 'Todos os Alertas',
      totalActive: 'Total Activos',
      critical: 'Críticos',
      high: 'Altos',
      medium: 'Médios',
      low: 'Baixos',
      newFollowup: 'Novo Follow-up',
      newFixedPayment: 'Novo Pagamento Fixo',
      recordExpense: 'Registar Despesa',
      replenishFund: 'Repor Fundo',
      markPaid: 'Marcar Pago',
      resolve: 'Resolver',
      clientName: 'Nome do Cliente',
      contactPhone: 'Telefone de Contacto',
      followupDate: 'Data do Follow-up',
      reason: 'Motivo',
      paymentName: 'Nome do Pagamento',
      paymentCategory: 'Categoria',
      paymentAmount: 'Valor',
      paymentFrequency: 'Frequência',
      dueDay: 'Dia de Vencimento',
      expenseDescription: 'Descrição da Despesa',
      expenseCategory: 'Categoria',
      daysOverdue: 'dias em atraso',
      dueThisWeek: 'A vencer esta semana',
      noAlerts: 'Nenhum alerta',
      noCriticalAlerts: 'Nenhum alerta crítico',
      noDebtors: 'Nenhuma dívida activa',
      noFollowups: 'Nenhum follow-up pendente',
      noFixedPayments: 'Nenhum pagamento fixo',
      noPettyCash: 'Nenhum fundo de caixa configurado',
      strategicControl: 'Controlo estratégico de todas as operações críticas',
      fixedPaymentsThisWeek: 'Pagamentos Fixos',
      thisWeek: 'Esta semana',
      criticalAlerts: 'Alertas Críticos',
      noPendingPayments: 'Nenhum pagamento pendente',
      emptyTitle: 'Sem alertas disponíveis',
      emptyDescription: 'A Central de Alertas abriu sem dados. Pode configurar/importar dados e tentar novamente.',
      loadError: 'Erro ao carregar alertas',
      resolveSuccess: 'Alerta resolvido',
      resolveError: 'Erro ao resolver alerta',
      requiredFields: 'Preencha os campos obrigatórios',
      followupCreated: 'Follow-up criado com sucesso',
      followupError: 'Erro ao criar follow-up',
      fixedPaymentCreated: 'Pagamento fixo criado',
      fixedPaymentError: 'Erro ao criar pagamento fixo',
      paymentRegistered: 'Pagamento registado',
      paymentRegisterError: 'Erro ao registar pagamento',
      expenseRecorded: 'Despesa registada',
      expenseRecordError: 'Erro ao registar despesa',
      fundReplenished: 'Fundo reposto',
      fundReplenishError: 'Erro ao repor fundo',
      activeAlertFallback: 'Alerta',
      unknownValue: 'N/D',
      nextDays: 'Próximos {{count}} dias',
      noLicensesExpiring: 'Nenhuma licença a expirar nos próximos {{count}} dias',
      noWarrantiesExpiring: 'Nenhuma garantia a expirar nos próximos {{count}} dias',
      licensesTitle: 'Alertas de Licenças',
      warrantiesTitle: 'Alertas de Garantias',
      expiresOn: 'Expira: {{date}}',
      daysRemaining: '{{count}} dias restantes',
      followupRequestsTitle: 'Pedidos de Contacto',
      newFollowupButton: 'Novo Follow-up',
      call: 'Ligar',
      resolved: 'Resolvido',
      debtorsTitle: 'Clientes Devedores',
      saleLabel: 'Venda: {{value}}',
      fromAmount: 'de {{value}}',
      fixedPaymentsTitle: 'Pagamentos Fixos',
      noFixedPaymentsConfigured: 'Nenhum pagamento fixo configurado',
      nextDue: 'Próximo: {{date}}',
      markPaidButton: 'Marcar Pago',
      pettyCashTitle: 'Fundo de Caixa',
      recordExpenseButton: 'Registar Despesa',
      ofAmount: 'de {{value}}',
      replenishFundButton: 'Repor Fundo',
      supplierDebtsTitle: 'Dívidas a Fornecedores',
      noSupplierDebts: 'Nenhuma dívida a fornecedores',
      poLabel: 'PO: {{value}}',
      dueDateLabel: 'Vencimento: {{date}}',
      allActiveAlertsTitle: 'Todos os Alertas Activos',
      noActiveAlerts: 'Nenhum alerta activo',
      followupDialogTitle: 'Novo Follow-up',
      fixedPaymentDialogTitle: 'Novo Pagamento Fixo',
      payFixedDialogTitle: 'Marcar Pagamento como Pago',
      expenseDialogTitle: 'Registar Despesa do Fundo de Caixa',
      replenishDialogTitle: 'Repor Fundo de Caixa',
      followupNamePlaceholder: 'Nome do cliente',
      followupReasonPlaceholder: 'Ex: Cliente pediu para ligar amanhã',
      fixedPaymentNamePlaceholder: 'Ex: Renda Loja Maputo',
      expenseLocationPlaceholder: 'Seleccionar localização',
      expenseDescriptionPlaceholder: 'Ex: Transporte de mercadorias',
      replenishAmountLabel: 'Valor a Repor (MZN)',
      currentBalance: 'Saldo actual: {{value}}',
      totalFund: 'Fundo total: {{value}}',
      confirmPayment: 'Confirmar Pagamento',
      createFixedPayment: 'Criar',
      createFollowup: 'Criar Follow-up',
      categoryRent: 'Renda',
      categoryWater: 'Água',
      categoryElectricity: 'Luz',
      categoryInternet: 'Internet',
      categorySalary: 'Salário',
      categoryOther: 'Outro',
      frequencyMonthly: 'Mensal',
      frequencyWeekly: 'Semanal',
      frequencyQuarterly: 'Trimestral',
      frequencyYearly: 'Anual',
      expenseCategoryTransport: 'Transporte',
      expenseCategoryMaintenance: 'Manutenção',
      expenseCategorySupplies: 'Material',
      expenseCategoryOther: 'Outro',
      paymentMethodCash: 'Numerário',
      paymentMethodMpesa: 'M-Pesa',
      paymentMethodEmola: 'E-MOLA',
      paymentMethodTransfer: 'Transferência'
    },
    // Services
    services: {
      title: 'Serviços',
      repairs: 'Reparações',
      gaming: 'Gaming Center',
      papelaria: 'Papelaria',
      others: 'Outros',
      newService: 'Novo Serviço',
      serviceNumber: 'Nº Serviço',
      customer: 'Cliente',
      device: 'Equipamento',
      issue: 'Problema',
      diagnosis: 'Diagnóstico',
      status: 'Estado',
      technician: 'Técnico',
      estimatedTime: 'Tempo Estimado',
      cost: 'Custo',
      pending: 'Pendente',
      reception: 'Em Recepção',
      inProgress: 'Em Progresso',
      awaitingParts: 'Aguarda Peças',
      awaitingApproval: 'Aguarda Aprovação',
      readyForPickup: 'Pronto Levantar',
      completed: 'Concluído',
      cancelled: 'Cancelado'
    },
    whatsappPage: {
      subtitle: 'Centro de notificações e mensagens via WhatsApp',
      connected: 'Conectado',
      disconnected: 'Desconectado',
      sandbox: 'Sandbox',
      emptyTitle: 'WhatsApp sem dados iniciais',
      emptyDescription: 'Verifique ligação, histórico e sandbox para que o canal continue operacional sem depender do legado.',
      emptyCta: 'Actualizar canal',
      stats: {
        sent: 'Mensagens Enviadas',
        delivered: 'Entregues',
        failed: 'Falharam',
        templates: 'Templates Disponíveis'
      },
      tabs: {
        send: 'Enviar Mensagem',
        templates: 'Templates',
        history: 'Histórico'
      },
      selectTemplateTitle: 'Seleccionar Template',
      selectTemplateDescription: 'Escolha um template pré-definido para enviar',
      sendMessageTitle: 'Enviar Mensagem',
      sendMessageDescription: 'Preencha os dados e envie a mensagem',
      phoneLabel: 'Número de Telefone',
      phoneHint: 'Formato: +258XXXXXXXXX (com código do país)',
      templatePrefix: 'Template',
      customMessageLabel: 'Ou envie mensagem personalizada',
      customMessagePlaceholder: 'Digite sua mensagem aqui...',
      sending: 'Enviando...',
      sendTemplate: 'Enviar Template',
      sendCustom: 'Enviar Personalizada',
      templatesTitle: 'Templates Disponíveis',
      templatesDescription: 'Visualize todos os templates de mensagem configurados',
      historyTitle: 'Histórico de Mensagens',
      historyDescription: 'Últimas {{count}} mensagens enviadas',
      refresh: 'Actualizar',
      noHistory: 'Nenhuma mensagem enviada ainda',
      sendFirstMessage: 'Enviar Primeira Mensagem',
      sandboxTitle: 'Configuração de Sandbox',
      sandboxDescription: 'Para testar mensagens, primeiro registe o seu número no Twilio Sandbox.',
      howToRegister: 'Como registar:',
      sandboxStep1: '1. Abra o WhatsApp no seu telefone',
      sandboxStep2: '2. Envie a mensagem',
      sandboxStep3: '3. Para o número',
      sandboxStep4: '4. Aguarde a confirmação do Twilio',
      qrHint: 'Escaneie o QR Code ou envie a mensagem manualmente',
      testSend: 'Testar Envio',
      status: {
        sent: 'Enviado',
        delivered: 'Entregue',
        read: 'Lido',
        failed: 'Falhou',
        queued: 'Em Fila'
      },
      templatesMap: {
        warranty_accepted: { name: 'Garantia Aceite', description: 'Notificar cliente que a garantia foi aprovada' },
        warranty_rejected: { name: 'Garantia Rejeitada', description: 'Informar que a garantia expirou com orçamento' },
        warranty_void: { name: 'Garantia Anulada', description: 'Notificar dano não coberto pela garantia' },
        sale_completed: { name: 'Venda Concluída', description: 'Confirmação de compra com detalhes' },
        repair_received: { name: 'Equipamento Recebido', description: 'Confirmar receção para reparação' },
        repair_in_progress: { name: 'Reparação em Curso', description: 'Atualização de progresso da reparação' },
        repair_completed: { name: 'Reparação Concluída', description: 'Notificar conclusão e pronto para levantamento' }
      },
      templates: {
        warranty_accepted: { name: 'Garantia Aceite', description: 'Notificar cliente que a garantia foi aprovada' },
        warranty_rejected: { name: 'Garantia Rejeitada', description: 'Informar que a garantia expirou com orçamento' },
        warranty_void: { name: 'Garantia Anulada', description: 'Notificar dano não coberto pela garantia' },
        sale_completed: { name: 'Venda Concluída', description: 'Confirmação de compra com detalhes' },
        repair_received: { name: 'Equipamento Recebido', description: 'Confirmar receção para reparação' },
        repair_in_progress: { name: 'Reparação em Curso', description: 'Atualização de progresso da reparação' },
        repair_completed: { name: 'Reparação Concluída', description: 'Notificar conclusão e pronto para levantamento' }
      }
    },
    papelariaPage: {
      title: 'Serviços de Papelaria',
      description: 'Topo reorganizado com linguagem de cockpit técnico: volume diário, receita, itens processados e parâmetros operacionais num mesmo plano de leitura.',
      badge: 'Papelaria',
      freeLabel: 'Livre',
      selectPlaceholder: 'Seleccionar',
      emptyTitle: 'Papelaria sem dados iniciais',
      emptyDescription: 'Configure serviços, localização e métodos de pagamento para evitar falhas totais no balcão de papelaria.',
      emptyCta: 'Abrir Configurações',
      availableServices: 'Serviços Disponíveis',
      availableServicesDescription: 'Clique para adicionar ao carrinho',
      cartTitle: 'Carrinho ({{count}})',
      emptyCart: 'Carrinho vazio',
      customerOptional: 'Cliente (opcional)',
      customerPlaceholder: 'Nome do cliente',
      payment: 'Pagamento',
      otherPayments: 'Outros...',
      datetimeOptional: 'Data/Hora (opcional)',
      total: 'Total',
      processing: 'A processar...',
      finishSale: 'Finalizar Venda',
      recentSales: 'Vendas Recentes',
      noRecentSales: 'Nenhuma venda registada hoje',
      stats: {
        salesToday: 'Vendas hoje',
        revenueToday: 'Receita hoje',
        location: 'Localização',
        employee: 'Colaborador',
        itemsHelper: '{{count}} itens',
        revenueHelper: 'Receita operacional',
        locationHelper: 'Loja em foco',
        employeeHelper: 'Atendimento corrente'
      }
    },
    globalFilters: {
      periods: {
        allTime: 'Todo período',
        today: 'Hoje',
        yesterday: 'Ontem',
        thisWeek: 'Esta Semana',
        thisMonth: 'Este Mês',
        lastMonth: 'Mês Anterior',
        thisYear: 'Este Ano',
        lastYear: 'Ano Passado',
        custom: 'Personalizado'
      },
      deleted: {
        active: 'Activos',
        deleted: 'Eliminados',
        all: 'Todos'
      },
      selectDates: 'Seleccionar datas',
      selectPeriod: 'Seleccione o período',
      from: 'De',
      to: 'Até',
      apply: 'Aplicar',
      location: 'Localização',
      allLocations: 'Todas Localizações',
      employee: 'Colaborador',
      allEmployees: 'Todos Colaboradores',
      status: 'Estado',
      allStatuses: 'Todos Estados',
      category: 'Categoria',
      allCategories: 'Todas Categorias',
      account: 'Conta',
      allAccounts: 'Todas Contas',
      activeFilters: '{{count}} filtro',
      clearFilters: 'Limpar filtros'
    },
    cashManagementPage: {
      title: 'Gestão de Caixa',
      description: 'Sessões, transferências e controlo de saldo',
      posCash: 'POS Caixa',
      posSales: 'POS Vendas',
      selectLocation: 'Selecionar Local',
      searchPlaceholder: 'Pesquisar código, local, motivo ou conta',
      searchHint: 'O filtro rápido aplica-se à aba actual para reduzir fricção diária.',
      emptyTitle: 'Gestão de caixa sem dados iniciais',
      emptyDescription: 'Configure localizações, contas de pagamento e tipos de operação para começar a registar sessões e transferências.',
      emptyCta: 'Abrir Configurações',
      opening: 'Abertura',
      closing: 'Fecho',
      difference: 'Diferença',
      type: 'Tipo',
      sourceDestination: 'Origem → Destino',
      reason: 'Motivo',
      pendingAlertsCount: '{{count}} alerta pendente',
      newTransfer: 'Nova Transferência',
      registerCheckpoint: 'Registar Checkpoint',
      refresh: 'Actualizar',
      tabs: { sessions: 'Sessões', transfers: 'Transferências', alerts: 'Alertas' },
      noSessions: 'Nenhuma sessão registada',
      noTransfers: 'Nenhuma transferência registada',
      systemAlerts: 'Alertas do Sistema',
      pendingBadge: '{{count}} pendentes',
      alertFilters: { open: 'Pendentes', resolved: 'Resolvidos', invalidScope: 'Fora de escopo', staleHistory: 'Histórico stale', all: 'Todos' },
      noOpenAlerts: 'Nenhum alerta pendente',
      noResolvedAlerts: 'Nenhum alerta resolvido',
      noAlerts: 'Nenhum alerta registado',
      resolve: 'Resolver',
      viewAlerts: 'Ver alertas',
      openSessionForAlert: 'Abrir sessão',
      archivedBatch: 'Batch',
      archivalReason: 'Regra',
      archivedAt: 'Arquivado em',
      selectedLocationFocus: 'Foco na localização actual',
      selectedLocationAlerts: '{{count}} alertas nesta localização',
      dailyCockpitTitle: 'Cockpit diário',
      dailyCockpitDescription: 'Leitura rápida para decidir abertura, fecho, pendências e histórico isolado.',
      operationalCards: {
        sessionState: 'Estado da operação',
        activeAlerts: 'Pendências activas',
        archivedAlerts: 'Histórico isolado',
        movements: 'Movimento do período',
        noLocation: 'Escolha um local para operar',
        noSession: 'Sem sessão aberta',
        sessionOpen: 'Sessão aberta',
        pendingOpening: 'Abertura pendente',
        activeAlertsHelper: '{{count}} alertas exigem acção prática',
        archivedAlertsHelper: '{{count}} alertas preservados fora da camada activa',
        sessionsHelper: '{{count}} sessões no período',
        checkpointsHelper: '{{count}} checkpoints registados',
        openAlertsAction: 'Abrir pendências',
        openArchivedAction: 'Ver histórico',
        openSessionAction: 'Abrir sessão',
        noImmediateAction: 'Sem acção imediata'
      },
      openSessionTitle: 'Abrir Sessão de Caixa',
      openSessionAction: 'Abrir Sessão',
      closeSessionTitle: 'Fechar Sessão de Caixa',
      closeSessionAction: 'Fechar Sessão',
      transferDialogTitle: 'Nova Transferência (TRF)',
      transferDialogDescription: 'Registe uma nova operação de caixa, transferência ou levantamento com rastreio completo.',
      registerTransfer: 'Registar Transferência',
      checkpointDialogTitle: 'Registar Checkpoint',
      checkpointDialogDescription: 'Registe uma verificação intermédia de saldo para reforçar o controlo operacional.',
      resolveAlertTitle: 'Resolver Alerta',
      confirmResolution: 'Confirmar Resolução',
      sessionDetailsTitle: 'Detalhes da Sessão',
      transferDetailsTitle: 'Detalhes da Transferência',
      openedBy: 'Aberta por',
      entries: 'Entradas',
      exits: 'Saídas',
      expenses: 'Despesas',
      justification: 'Justificação',
      closedByAt: 'Fechada por {{name}} às {{date}}',
      sourceAccount: 'Conta de Origem',
      destinationAccount: 'Conta de Destino',
      attachments: 'Comprovantes',
      registeredByAt: 'Registado por {{name}} em {{date}}',
      resolutionComment: 'Comentário de Resolução',
      resolutionPlaceholder: 'Explique como o alerta foi resolvido ou justifique a situação...',
      resolutionHint: 'O comentário é obrigatório e será registado no histórico do sistema.',
      checkpointInfo: 'Checkpoints são verificações periódicas do saldo em caixa para garantir controlo.',
      sessionLabel: 'Sessão',
      noActiveSession: 'Sem sessão aberta',
      openSessionHint: 'Abra uma sessão para registar operações',
      sessionOpenedBy: 'Aberta às {{date}} por {{name}}',
      expectedBalance: 'Saldo Esperado',
      openingBalance: 'Saldo Inicial',
      filters: {
        allSessionStatuses: 'Todos os estados da sessão',
        allDirections: 'Todas as direcções',
        allOperationTypes: 'Todos os tipos de operação',
        allAlertTypes: 'Todos os tipos de alerta'
      },
      sessionSummary: {
        open: '{{count}} abertas',
        closed: '{{count}} fechadas',
        pending: '{{count}} pendentes'
      },
      transferSummary: {
        in: '{{count}} entradas',
        out: '{{count}} saídas',
        transfer: '{{count}} transferências'
      },
      alertSummary: {
        missedCheckpoint: '{{count}} checkpoints em falta',
        noOpening: '{{count}} sem abertura',
        noClosing: '{{count}} sem fecho'
      },
      statusLabels: {
        open: 'Aberta',
        closed: 'Fechada',
        pending_reconciliation: 'Pendente'
      },
      directionLabels: {
        in: 'Entrada',
        out: 'Saída',
        transfer: 'Transferência'
      },
      severityLabels: {
        critical: 'Crítico',
        high: 'Alto',
        warning: 'Atenção',
        medium: 'Médio',
        low: 'Baixo'
      },
      alertStatusLabels: {
        open: 'Activo',
        resolved: 'Resolvido',
        invalid_scope: 'Fora de escopo',
        stale_history: 'Histórico stale'
      },
      archivalReasonLabels: {
        invalid_location_scope: 'Inválido por escopo',
        stale_past_day: 'Stale de dia passado'
      },
      alertTypes: {
        open: 'Pendentes',
        resolved: 'Resolvidos',
        all: 'Todos',
        missedCheckpoint: 'Checkpoint em Falta',
        noOpening: 'Sessão não Aberta',
        noClosing: 'Sessão não Fechada'
      },
      closeSessionDescription: 'Informe o saldo de fecho e justifique diferenças se necessário.',
      transferDetailsDescription: 'Detalhes completos da transferência de caixa.',
      resolveAlertDescription: 'Adicione um comentário para resolver este alerta.'
    },
    catalogsPage: {
      expenseCategoriesTitle: 'Categorias de Despesas (PGT)',
      newCategory: 'Nova Categoria',
      repairTypesTitle: 'Tipos de Reparação (SR)',
      newType: 'Novo Tipo',
      cashOpsTitle: 'Operações de Caixa (TRF)',
      resetCashOps: 'Repor TRF Base',
      noCashOps: 'Sem operações TRF visíveis neste momento.',
      noCashOpsHelp: 'Use a reposição base para voltar a ter tipos de operação prontos a usar quando precisar.'
    },
    procurementPage: {
      title: 'Gestão de Compras',
      description: 'Gerir fornecedores e ordens de compra',
      stockTransfers: 'Transferências',
      services: 'Serviços',
      searchPlaceholder: 'Pesquisar...',
      emptyTitle: 'Compras sem dados iniciais',
      emptyDescription: 'Adicione fornecedores e produtos base para que o módulo continue operacional mesmo quando parte do legado falha.',
      emptyCta: 'Abrir Inventário',
      tabs: {
        purchaseOrders: 'Ordens de Compra',
        suppliers: 'Fornecedores',
        deletedSuppliers: 'Fornecedores Eliminados',
        cancelledPOs: 'POs Canceladas'
      },
      newPO: 'Nova Ordem de Compra',
      clearSelection: 'Limpar selecção',
      selectVisible: 'Seleccionar visíveis',
      approve: 'Aprovar',
      receive: 'Receber',
      configurableXlsx: 'XLSX Configurável',
      loadingPOs: 'A carregar ordens de compra...',
      noPOs: 'Sem ordens de compra',
      addSupplier: 'Adicionar Fornecedor',
      loadingSuppliers: 'A carregar fornecedores...',
      noSupplierFound: 'Nenhum fornecedor encontrado',
      noSuppliers: 'Sem fornecedores. Adicione o primeiro!',
      deletedSuppliersTitle: 'Fornecedores Eliminados ({{count}})',
      noDeletedSuppliers: 'Sem fornecedores eliminados',
      deletedAtBy: 'Eliminado em {{date}} por {{name}}',
      cancelledPOsTitle: 'Ordens de Compra Canceladas ({{count}})',
      noCancelledPOs: 'Sem ordens de compra canceladas',
      cancelledAt: 'Cancelado em',
      cancelledBy: 'Cancelado por',
      reasonLabel: 'Motivo',
      exportDialogTitle: 'Exportar POs para XLSX',
      exportDialogDescription: 'Escolha as colunas que devem entrar no ficheiro das ordens de compra seleccionadas.',
      bulkCancelTitle: 'Cancelar ordens de compra em massa',
      bulkCancelDescription: 'Informe o motivo para cancelar as POs seleccionadas. O sistema ignora automaticamente POs que já não possam ser canceladas.',
      bulkCancelPlaceholder: 'Motivo do cancelamento em massa',
      confirmCancellation: 'Confirmar cancelamento',
      addSupplierTitle: 'Adicionar Novo Fornecedor',
      supplierName: 'Nome do Fornecedor',
      contactPerson: 'Pessoa de Contacto',
      taxId: 'NUIT',
      address: 'Morada',
      city: 'Cidade',
      paymentTerms: 'Termos de Pagamento',
      paymentTermsPlaceholder: 'Ex: Net 30, À vista'
    },
    rolesPermissionsPage: {
      title: 'Perfis do sistema',
      description: 'Organização integrada por módulos, incluindo perfis base e perfis criados, para ajuste mais fácil dos acessos.',
      hideDeleted: 'Ocultar apagados',
      showDeleted: 'Mostrar apagados',
      newRole: 'Novo Perfil',
      rolesCount: '{{count}} perfil(is) integrado(s) · {{modules}} módulos reconhecidos',
      loadingRoles: 'A carregar perfis...',
      noRoles: 'Nenhum perfil encontrado.',
      assignmentTitle: 'Atribuição de perfil',
      assignmentDescription: 'Associe um perfil configurável a cada utilizador sem perder o papel base do sistema.',
      loadingUsers: 'A carregar utilizadores...',
      noUsers: 'Nenhum utilizador encontrado.'
    },
    notificationBell: {
      title: 'Notificações',
      disabled: 'Notificações desactivadas',
      enabled: 'Notificações activadas!',
      enableError: 'Erro ao activar notificações',
      preferencesSaved: 'Preferências guardadas',
      preferencesError: 'Erro ao guardar preferências',
      enableDescription: 'Active as notificações para receber alertas críticos do sistema.',
      enableBrowser: 'Activar Notificações no Navegador',
      blockedWarning: '⚠️ Notificações bloqueadas. Verifique as definições do browser.',
      noPending: 'Sem alertas pendentes',
      viewAllAlerts: 'Ver Todos os Alertas',
      preferencesTitle: 'Preferências de Notificações',
      preferencesDescription: 'Escolha quais alertas críticos deseja receber.',
      pushTitle: 'Notificações Push',
      pushDescription: 'Receber alertas no navegador',
      checkpointDescription: 'Alertas de checkpoints não registados',
      sessionDescription: 'Alertas de abertura/fecho de sessão',
      varianceDescription: 'Alertas de variações > 1 MZN',
      saving: 'A guardar...',
      savePreferences: 'Guardar Preferências'
    },
    salesCashPanel: {
      title: 'POS + Caixa Integrado',
      description: 'Vendas e caixa partilham a mesma localização operacional. Sem sessão aberta, venda confirmada não é permitida.',
      selectLocationError: 'Seleccione uma localização para abrir o caixa',
      invalidOpeningBalance: 'Saldo inicial inválido',
      sessionOpened: 'Sessão de caixa aberta com sucesso',
      openError: 'Erro ao abrir sessão de caixa',
      noActiveSession: 'Não há sessão activa para fechar',
      invalidClosingBalance: 'Saldo de fecho inválido',
      sessionClosed: 'Sessão de caixa fechada com sucesso',
      closeError: 'Erro ao fechar sessão de caixa',
      sessionOpen: 'Sessão Aberta',
      sessionClosedLabel: 'Sessão Fechada',
      noLocationSelected: 'Sem localização seleccionada',
      openingBalance: 'Saldo Inicial',
      sessionSales: 'Vendas da Sessão',
      openedAt: 'Aberta em',
      noSessionForLocation: 'Nenhuma sessão de caixa aberta para esta localização.',
      openIntegratedCash: 'Abrir Caixa Integrado',
      closeCash: 'Fechar Caixa',
      openCashCenter: 'Abrir Centro de Caixa',
      openDialogTitle: 'Abrir Sessão de Caixa',
      openDialogDescription: 'A sessão será aberta para {{location}}.',
      selectedLocationFallback: 'a localização seleccionada',
      opening: 'A abrir...',
      confirmOpen: 'Confirmar abertura',
      closeDialogTitle: 'Fechar Sessão de Caixa',
      closeDialogDescription: 'Informe o saldo final apurado para concluir o fecho.',
      closingBalance: 'Saldo de fecho',
      differenceJustification: 'Justificação da diferença (se existir)',
      closingNotes: 'Notas de fecho',
      closing: 'A fechar...',
      confirmClose: 'Confirmar fecho'
    },
    vatConfigPage: {
      title: 'Configuração de IVA',
      description: 'Configurar taxa e regime padrão de IVA para o sistema (Moçambique: 16%)',
      loadError: 'Erro ao carregar configuração IVA',
      saveSuccess: 'Configuração IVA actualizada com sucesso!',
      saveError: 'Erro ao guardar configuração',
      calculateError: 'Erro ao calcular IVA',
      rulesTitle: 'Regras de IVA Obrigatórias',
      defaultRate: 'Taxa de IVA Padrão (%)',
      mozRate: 'Moçambique: 16%',
      defaultRateHint: 'Taxa aplicada por defeito a novos produtos e documentos',
      defaultRegime: 'Regime de IVA Padrão',
      selectRegime: 'Seleccionar regime',
      defaultRegimeHint: 'Define se os preços incluem ou excluem IVA por defeito',
      quickPresets: 'Presets rápidos',
      impactPreview: 'Impacto padrão (preview)',
      impactDescription: 'Para um valor base de {{value}}, o sistema aplicará por padrão:',
      saving: 'A guardar...',
      saveButton: 'Guardar Configuração',
      calculatorTitle: 'Calculadora de IVA',
      calculatorDescription: 'Testar cálculo de IVA com a configuração actual',
      testPrice: 'Preço de Teste (MT)',
      calculateButton: 'Calcular',
      currentConfig: 'Configuração Actual'
    },
    serialNumbersPanel: {
      title: 'Números de Série',
      summary: '{{product}} • {{count}} registos',
      addShort: 'Adicionar SN',
      searchPlaceholder: 'Pesquisar IMEI ou número de série...',
      identifier: 'Identificador',
      stateLocation: 'Estado / Localização',
      details: 'Detalhes',
      empty: 'Nenhum número de série encontrado'
    },
    welcomeTour: {
      stepCounter: 'Passo {{current}} de {{total}}',
      skip: 'Saltar Tour',
      finish: 'Concluir',
      steps: {
        welcome: { title: 'Bem-vindo ao CG Business ERP!', content: 'Este tour vai apresentar-lhe as principais funcionalidades do sistema adaptadas ao perfil {{profileName}}.' },
        dashboard: { title: 'Dashboard Principal', content: 'O Dashboard apresenta KPIs, gráficos e métricas do negócio em tempo real. Aqui pode monitorar vendas, despesas e performance.' },
        sales: { title: 'Vendas / POS', content: 'O módulo de vendas suporta IVA de 16%, múltiplas formas de pagamento e impressão de documentos fiscais.' },
        inventory: { title: 'Gestão de Inventário', content: 'Controle produtos, stock por localização, rastreamento IMEI/Série e alertas de stock baixo.' },
        clients: { title: 'Gestão de Clientes', content: 'CRM completo com histórico de compras, alertas e gestão de créditos.' },
        services: { title: 'Serviços e Reparações', content: 'Registe reparações, diagnósticos, cotações e acompanhe o estado de cada serviço.' },
        projects: { title: 'Obras / Projectos Técnicos', content: 'No módulo Obras (dentro de Serviços) pode gerir checklists por tipo de instalação, assinaturas e progresso para o cliente.' },
        cash: { title: 'Gestão de Caixa', content: 'Abra e feche sessões de caixa, faça transferências e reconciliações diárias.' },
        documents: { title: 'Documentos Comerciais', content: 'Aqui controla cotações, documentos fiscais, notas de crédito e o fluxo documental por localização.' },
        stockTransfers: { title: 'Transferências de Stock', content: 'Transfira stock entre localizações com rastreio operacional, motivos e histórico auditável.' },
        receivables: { title: 'Contas a Receber', content: 'Acompanhe dívidas, recibos, liquidações parciais e seguimento financeiro por cliente.' },
        expenses: { title: 'Gestão de Despesas', content: 'Registe despesas multi-itens, acompanhe PGT, filtros operacionais e histórico de aprovação.' },
        payroll: { title: 'Folha Salarial (RH)', content: 'Acompanhe folhas salariais, assiduidade, documentos obrigatórios e relatórios de RH sem confundir este módulo com a Análise Financeira.' },
        procurement: { title: 'Compras e Procurement', content: 'Gerencie ordens de compra, fornecedores, aprovações e ligação ao pricing.' },
        suppliers: { title: 'Fornecedores', content: 'Centralize fornecedores, catálogo, actividade e dados de compra com leitura operacional clara.' },
        pricing: { title: 'Pricing e Custos', content: 'Reveja margens, custos e fornecedores para suportar decisões comerciais e de compra.' },
        reports: { title: 'Relatórios', content: 'Consulte relatórios executivos, exportações e agendas recorrentes para operação e controlo.' },
        feedback: { title: 'Feedback e Suporte', content: 'Registe feedback, acompanhe tickets internos e partilhe melhorias operacionais com contexto.' },
        alerts: { title: 'Alertas Operacionais', content: 'Receba alertas críticos de stock, operação e supervisão para responder com prioridade.' },
        licenses: { title: 'Licenças', content: 'Veja o estado das licenças, renovações e controlo documental associado aos activos digitais.' },
        users: { title: 'Gestão de Utilizadores', content: 'Crie e gerencie utilizadores directamente dentro do Centro Administrativo, com perfis e trilho de alterações no mesmo cockpit.' },
        integrity: { title: 'Verificação de Integridade', content: 'Módulo anti-fraude que verifica inconsistências e detecta actividades suspeitas.' },
        settings: { title: 'Configurações', content: 'Configure lojas, formas e contas de pagamento, IVA e parâmetros operacionais que alimentam o ERP.' },
        templateBuilder: { title: 'Template Builder e Impressões', content: 'Monte templates, snippets e blocos bancários com preview visual e PDFs alinhados ao documento real.' },
        financial: { title: 'Análise Financeira', content: 'Analise lucros, margens e performance por loja com indicadores financeiros detalhados.' },
        about: { title: 'Manual, Dossier e Relatório Final', content: 'Na página "Sobre" pode descarregar o Manual de Utilizador, o Dossier Técnico e o Relatório Final Go-Live.' }
      }
    },
    expensesPage: {
      title: 'Gestão de Despesas',
      subtitle: '{{count}} despesas',
      newExpense: 'Nova Despesa',
      registerExpense: 'Registar Despesa'
    },
    pricingPage: {
      title: 'Gestão de Preços',
      description: 'Fornecedores, preços de custo e análise de margem',
      newSupplier: 'Novo Fornecedor',
      tabs: { suppliers: 'Fornecedores', comparison: 'Comparação', weekly: 'Relatório Semanal', alerts: 'Alertas de Margem' },
      stats: {
        activeSuppliers: 'Fornecedores Activos',
        marginAlerts: 'Alertas de Margem',
        critical: 'Críticos (Abaixo Custo)',
        minimumMargin: 'Margem Mínima'
      }
    },
    clientsPage: {
      title: 'Clientes',
      description: 'Gestão de clientes particulares e empresas',
      templateExcel: 'Template Excel',
      importExcel: 'Importar Excel',
      deactivate: 'Desativar',
      newClient: 'Novo Cliente',
      searchPlaceholder: 'Nome, NUIT, telefone, email...',
      type: 'Tipo',
      all: 'Todos',
      individual: 'Particular',
      company: 'Empresa',
      showDeleted: 'Mostrar eliminados',
      listTitle: 'Lista de Clientes ({{count}})',
      loading: 'Carregando...',
      noClientsFound: 'Nenhum cliente encontrado'
    },
    suppliersPage: {
      title: 'Fornecedores',
      description: 'Relação com fornecedores, estados de actividade e controlo de catálogo num topo visual mais alinhado com Clientes e o restante ERP.',
      badge: 'Compras',
      templateExcel: 'Template Excel',
      importExcel: 'Importar Excel',
      deactivate: 'Desativar',
      hideDeleted: 'Ocultar apagados',
      showDeleted: 'Mostrar apagados',
      newSupplier: 'Novo Fornecedor',
      searchPlaceholder: 'Pesquisar por nome, código ou NUIT...',
      listTitle: 'Lista de Fornecedores',
      listCount: '{{count}} fornecedor(es) encontrado(s)',
      noSuppliersFound: 'Nenhum fornecedor encontrado',
      stats: {
        total: 'Total Fornecedores',
        totalHelper: 'Registos carregados',
        active: 'Activos',
        activeHelper: 'Fornecedores operacionais',
        inactive: 'Inactivos',
        inactiveHelper: 'Em pausa ou arquivo',
        lastCode: 'Último Código',
        lastCodeHelper: 'Referência mais recente'
      }
    },
    payrollPage: {
      title: 'Folha Salarial (RH)',
      description: 'Processamento salarial, confirmação e pagamento com leitura mais clara para RH, finanças e supervisão interna.',
      badge: 'RH',
      noAccessTitle: 'Sem acesso à Folha Salarial (RH)',
      noAccessDescription: 'Precisa da permissão payroll.view ou payroll.edit para abrir este módulo.',
      processSalary: 'Processar Salário',
      processDialogTitle: 'Processar Folha Salarial (RH)',
      processDialogDescription: 'Cálculo automático de INSS ({{employeeRate}}%+{{employerRate}}%) e IRPS. Comissão: {{commissionRate}}% sobre vendas quando meta atingida.',
      selectEmployee: 'Seleccionar funcionário',
      incomplete: 'Incompleto ({{count}}%)',
      completeDossierFirst: 'Complete o dossier do funcionário antes de processar',
      month: 'Mês',
      year: 'Ano',
      earnings: 'Rendimentos',
      baseSalary: 'Salário Base',
      manualCommission: 'Comissão Manual',
      automatic: 'Automático',
      simulate: 'Simular',
      simulationFor: 'Simulação: {{employee}}',
      periodLabel: 'Período',
      commission: 'Comissão',
      bonuses: 'Bónus',
      allowances: 'Subsídios',
      grossSalary: 'Salário Bruto',
      totalDeductions: 'Total Descontos',
      netSalary: 'Salário Líquido',
      employerContributionInfo: 'Contribuição Patronal (Info)',
      fillAndSimulate: 'Preencha os dados e clique em "Simular" para ver o cálculo',
      processing: 'A processar...',
      processPayroll: 'Processar Folha',
      stats: {
        payrolls: 'Folhas',
        payrollsHelper: 'Registos do período actual',
        drafts: 'Rascunhos',
        draftsHelper: 'Ainda por confirmar',
        confirmed: 'Confirmadas',
        confirmedHelper: 'Prontas para pagamento',
        paid: 'Pagas',
        paidHelper: 'Processadas com sucesso'
      }
    },
    attachmentUploader: {
      saveBeforeUpload: 'Guarde o registo antes de adicionar anexos',
      maxFiles: 'Máximo de {{count}} ficheiros permitidos',
      fileUploaded: 'Ficheiro carregado',
      filesUploaded: '{{count}} ficheiro(s) carregado(s)',
      uploadError: 'Erro ao carregar ficheiro',
      deleted: 'Anexo eliminado',
      deleteError: 'Erro ao eliminar anexo',
      uploading: 'A carregar...',
      dropHere: 'Largue os ficheiros aqui',
      dragOrClick: 'Arraste ficheiros ou clique para seleccionar',
      fileHint: 'PDF, JPG, PNG até {{size}}MB (máx. {{count}} ficheiros)',
      takePhoto: 'Tirar foto',
      attachmentsCount: 'Anexos ({{count}})',
      noAttachments: 'Sem anexos',
      deleteTitle: 'Eliminar Anexo',
      deleteDescription: 'Tem a certeza que deseja eliminar “{{file}}”? Esta acção será registada na auditoria.',
      reasonOptional: 'Motivo (opcional)',
      reasonPlaceholder: 'Descreva o motivo da eliminação...'
    },
    // Financial Analysis
    financial: {
      title: 'Análise Financeira',
      subtitle: 'Controlo de lucro real, rotação de stock e análise de fornecedores',
      realProfit: 'Lucro Real',
      byLocation: 'Por Loja',
      supplierAnalysis: 'Fornecedores',
      stockRotation: 'Rotação Stock',
      totalRevenue: 'Receita Total',
      totalCosts: 'Custos Totais',
      netProfit: 'Lucro Líquido',
      staleStock: 'Stock Parado',
      profitByService: 'Lucro por Tipo de Serviço',
      profitByProduct: 'Lucro por Produto (Top 10)',
      margin: 'Margem',
      highRotation: 'Alta Rotação',
      lowRotation: 'Baixa Rotação',
      stockAlerts: 'Alertas de Stock'
    },
    // Risk Management
    risk: {
      title: 'Gestão de Risco',
      subtitle: 'Controlo de clientes, fraude e disciplina financeira',
      clientRisk: 'Risco Clientes',
      fraud: 'Fraude',
      locations: 'Lojas',
      audit: 'Auditoria',
      highRiskClients: 'Clientes Alto Risco',
      blockedClients: 'Clientes Bloqueados',
      totalDebt: 'Dívida Total',
      suspiciousActivities: 'Actividades Suspeitas',
      underperformingLocations: 'Lojas Deficitárias',
      riskAssessment: 'Avaliação de Risco de Clientes',
      noRiskClients: 'Nenhum cliente com risco',
      creditLimit: 'Limite de Crédito',
      paymentHistory: 'Histórico de Pagamentos'
    },
    // Language
    language: {
      title: 'Idioma',
      portuguese: 'Português',
      english: 'Inglês',
      changed: 'Idioma alterado para {{language}}'
    }
  },
  
  en: {
    // Menu Groups
    menu: {
      panel: 'DASHBOARD',
      operations: 'OPERATIONS',
      financial: 'FINANCIAL',
      relations: 'RELATIONS',
      system: 'SYSTEM'
    },
    // Navigation Items
    nav: {
      dashboard: 'Main Dashboard',
      financialAnalysis: 'Financial Analysis',
      riskManagement: 'Risk Management',
      inventory: 'Inventory',
      sales: 'Sales',
      services: 'Services',
      procurement: 'Procurement',
      kits: 'Kits / Bundles',
      documents: 'Documents',
      stockTransfers: 'Stock Transfers',
      receivables: 'Receivables',
      cash: 'Cash',
      expenses: 'Expenses',
      payroll: 'Payroll (HR)',
      pricing: 'Pricing & Costs',
      clients: 'Clients',
      licenses: 'Licenses',
      alerts: 'Alerts',
      catalogs: 'Catalogs',
      adminCenter: 'Admin Center',
      users: 'Users',
      userManagement: 'User Management',
      whatsapp: 'WhatsApp',
      reports: 'Reports',
      feedback: 'Feedback',
      integrity: 'Integrity',
      settings: 'Settings',
      templateBuilder: 'Template Builder',
      suppliers: 'Suppliers',
      projects: 'Projects',
      about: 'About'
    },
    roles: {
      admin: 'Administrator',
      store_manager: 'Manager',
      accountant: 'Accountant',
      seller: 'Salesperson',
      technician: 'Technician',
      staff: 'Staff',
      cashier: 'Cashier'
    },
    sidebar: {
      systemOnline: 'System Online'
    },
    // Common Actions
    actions: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      restore: 'Restore',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      import: 'Import',
      refresh: 'Refresh',
      close: 'Close',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      add: 'Add',
      remove: 'Remove',
      view: 'View',
      download: 'Download',
      upload: 'Upload',
      print: 'Print',
      send: 'Send',
      approve: 'Approve',
      reject: 'Reject',
      submit: 'Submit',
      logout: 'Logout'
    },
    // Common Labels
    labels: {
      name: 'Name',
      email: 'Email',
      password: 'Password',
      phone: 'Phone',
      address: 'Address',
      date: 'Date',
      time: 'Time',
      status: 'Status',
      type: 'Type',
      search: 'Search',
      category: 'Category',
      description: 'Description',
      notes: 'Notes',
      amount: 'Amount',
      total: 'Total',
      subtotal: 'Subtotal',
      quantity: 'Quantity',
      price: 'Price',
      cost: 'Cost',
      profit: 'Profit',
      discount: 'Discount',
      tax: 'Tax',
      reference: 'Reference',
      number: 'Number',
      code: 'Code',
      datetime: 'Date/Time',
      location: 'Location',
      employee: 'Employee',
      client: 'Client',
      customer: 'Customer',
      supplier: 'Supplier',
      product: 'Product',
      service: 'Service',
      payment: 'Payment',
      all: 'All',
      none: 'None',
      yes: 'Yes',
      no: 'No',
      active: 'Active',
      inactive: 'Inactive',
      pending: 'Pending',
      completed: 'Completed',
      cancelled: 'Cancelled',
      approved: 'Approved',
      rejected: 'Rejected'
    },
    // Periods
    periods: {
      allTime: 'All Time',
      today: 'Today',
      yesterday: 'Yesterday',
      thisWeek: 'This Week',
      lastWeek: 'Last Week',
      thisMonth: 'This Month',
      lastMonth: 'Last Month',
      thisQuarter: 'This Quarter',
      thisYear: 'This Year',
      lastYear: 'Last Year',
      custom: 'Custom'
    },
    // Messages
    messages: {
      loading: 'Loading...',
      saving: 'Saving...',
      saved: 'Saved successfully',
      deleted: 'Deleted successfully',
      error: 'An error occurred',
      noData: 'No data',
      noResults: 'No results found',
      confirmDelete: 'Are you sure you want to delete?',
      required: 'Required field',
      invalidEmail: 'Invalid email',
      invalidPhone: 'Invalid phone',
      success: 'Operation completed successfully',
      logout: 'Session ended'
    },
    // Dashboard
    dashboard: {
      title: 'Main Dashboard',
      subtitle: 'Business overview',
      totalRevenue: 'Total Revenue',
      totalExpenses: 'Total Expenses',
      netProfit: 'Net Profit',
      avgTicket: 'Avg Ticket',
      salesEvolution: 'Sales Evolution',
      expensesByCategory: 'Expenses by Category',
      topProducts: 'Top Products',
      topEmployees: 'Top Employees',
      cashByLocation: 'Cash by Location',
      recentSales: 'Recent Sales',
      netResult: 'Net Result',
      cashDifference: 'Cash Difference',
      alerts: 'Alerts',
      previousPeriod: 'vs previous period',
      salesCount: '{{count}} sales',
      performanceOverTime: 'Performance over time',
      selectedPeriod: 'Period',
      salesLabel: 'Sales',
      noSalesInPeriod: 'No sales data for this period',
      noExpensesInPeriod: 'No expenses for this period',
      productsSold: '{{count}} sold',
      noTopEmployees: 'No seller data for this period',
      quickActions: 'Quick Actions',
      newSale: 'New Sale',
      newQuotation: 'New Quote',
      newClient: 'New Client',
      newService: 'New Service',
      inventory: 'Inventory',
      lowStockBadge: '{{count}} low',
      requiresAttention: 'Needs Attention',
      waitingServices: 'Services waiting',
      pendingQuotations: 'Pending quotations',
      lowStock: 'Low stock',
      recentActivity: 'Recent Activity',
      noRecentActivity: 'No recent activity',
      performanceScore: 'Performance Score',
      points: 'points',
      excellentPerformance: 'Excellent performance!',
      keepGoing: 'Great job! Keep it up.',
      roomToImprove: 'There is room to improve!',
      topExpenses: 'Top 5 Highest Expenses',
      viewAll: 'View all',
      viewFullReport: 'View full report',
      loadError: 'Failed to load dashboard',
      refreshed: 'Dashboard refreshed!',
      accessRestricted: 'Restricted Access',
      accessRestrictedDescription: 'The dashboard is available only to authorized users.',
      greeting: 'Hello, {{name}}! Here is your business summary.',
      defaultUserName: 'User',
      live: 'Live',
      allLocations: 'All Locations',
      defaultLocationBadge: 'Default store: {{location}}',
      loading: 'Loading dashboard...',
      emptyStateTitle: 'Dashboard without enough data',
      emptyStateDescription: 'There are not enough indicators, charts, or rankings for this period yet. You can review the full reports or load operational data.',
      activityFeed: {
        title: '{{entity}}: {{action}}',
        unknownActor: 'System',
        noDetails: 'No extra details',
        entities: {
          sale: 'Sale',
          service: 'Service',
          client: 'Client',
          supplier: 'Supplier',
          user: 'User',
          stock: 'Stock',
          expense: 'Expense',
          payment: 'Payment',
          document: 'Document',
          settings: 'Setting',
          generic: 'Activity'
        },
        actions: {
          created: 'created',
          updated: 'updated',
          edited: 'edited',
          deleted: 'deleted',
          hard_deleted: 'permanently deleted',
          restored: 'restored',
          approved: 'approved',
          rejected: 'rejected',
          processed: 'processed',
          confirmed: 'confirmed',
          cancelled: 'cancelled',
          closed: 'closed',
          completed: 'completed',
          opened: 'opened',
          registered: 'registered',
          paid: 'paid',
          bulk_updated: 'bulk updated',
          stock_adjusted: 'stock adjusted',
          user_updated: 'user updated',
          dossier_updated: 'dossier updated',
          language_preference_updated: 'language updated',
          welcome_tour_preference_updated: 'welcome tour updated',
          password_reset_completed_public: 'password reset',
          user_deleted: 'user deleted',
          default: 'updated'
        }
      },
      activity: {
        newSaleTitle: 'New sale recorded',
        newSaleDescription: 'Sale #2024-001 - Walk-in customer',
        completedServiceTitle: 'Service completed',
        completedServiceDescription: 'iPhone 13 screen repair',
        newClientTitle: 'New client',
        newClientDescription: 'ABC Ltd company registered',
        sentQuotationTitle: 'Quotation sent',
        sentQuotationDescription: 'QTN-2024-089 awaiting approval',
        lowStockTitle: 'Low stock',
        lowStockDescription: 'iPhone 15 Pro - Only 2 units left',
        time2m: '2 min',
        time15m: '15 min',
        time30m: '30 min',
        time1h: '1h',
        time2h: '2h'
      }
    },
    login: {
      welcomeToast: 'Welcome to CG Business ERP!',
      invalidCredentials: 'Invalid credentials. Please check your email and password.',
      identifierLabel: 'Username or email',
      identifierPlaceholder: 'username or email@company.com',
      userNotFound: 'Username or email not found',
      wrongPassword: 'Incorrect password',
      technicalError: 'Technical error while signing in',
      systemLabel: 'Business Management System',
      accessPanel: 'Sign in to access your control panel',
      signInTitle: 'Sign In',
      signInDescription: 'Enter your credentials to continue',
      showPassword: 'Show',
      hidePassword: 'Hide',
      signingIn: 'Signing in...',
      signInButton: 'Sign in',
      headline: 'The most complete ERP in Mozambique',
      subheadline: 'Integrated management for sales, inventory, services, finance and much more. Everything on a single platform.',
      featurePosTitle: 'Advanced Point of Sale',
      featurePosDescription: '16% VAT, multiple payments, POS printing and invoices',
      featureInventoryTitle: 'Inventory Management',
      featureInventoryDescription: '308+ products, stock control by location, IMEI/Serial',
      featureCrmTitle: 'Integrated CRM',
      featureCrmDescription: '311+ clients, purchase history, automatic alerts',
      featureAnalyticsTitle: 'Real-Time Analytics',
      featureAnalyticsDescription: 'Smart dashboard, KPIs, financial reports',
      modulesLabel: 'Modules',
      vatLabel: 'Mozambique VAT',
      operationalLabel: 'Operational',
      secureSsl: 'Secure SSL',
      protectedData: 'Protected Data',
      locationDialogTitle: 'Choose default store for documents',
      locationDialogDescription: 'By default, we use the store from your user profile. You can change it below for this session.',
      locationDialogLabel: 'Default store for documents',
      locationDialogPlaceholder: 'Select a store',
      continueButton: 'Continue',
      forgotPassword: 'Forgot password?'
    },
    passwordReset: {
      dialogTitle: 'Recover password',
      dialogDescription: 'Enter your email and we will send a secure link to reset your password.',
      emailPlaceholder: 'your@email.com',
      sendLink: 'Send recovery link',
      sendingLink: 'Sending...',
      requestSuccess: 'If the email exists in the system, we will send a recovery link.',
      requestError: 'Unable to send the recovery link.',
      providerRestriction: 'Recovery email is blocked because Resend is in test mode. Verify a domain in Resend to send links to other users.',
      pageTitle: 'Set a new password',
      pageDescription: 'Create a new password to access your account again.',
      newPassword: 'New password',
      confirmPassword: 'Confirm new password',
      resetButton: 'Reset password',
      resetting: 'Resetting...',
      success: 'Password reset successfully. Please sign in with your new password.',
      mismatch: 'Passwords do not match.',
      invalidLinkTitle: 'Invalid or expired link',
      invalidLinkDescription: 'Request a new recovery email to continue.',
      backToLogin: 'Back to login',
      requestAnother: 'Request another link',
      validatedFor: 'Valid link for {{email}}',
      helper: 'Use at least 8 characters for better security.'
    },
    documents: {
      emptyTitle: 'No data available',
      emptyDescription: 'No records found for Commercial Documents. You can configure or import data to get started.',
      title: 'Commercial Documents',
      description: 'Quotations, delivery guides and reception guides with clearer reading, faster operation and top-of-page metrics.',
      badge: 'Commercial',
      quotationsLabel: 'Quotations',
      quotationsPendingHelper: '{{count}} pending',
      conversionRateLabel: 'Conversion Rate',
      conversionRateHelper: 'Quotations converted into fiscal documents',
      receptionGuidesLabel: 'Reception Guides',
      receptionGuidesHelper: 'Reception entries recorded',
      deliveryGuidesLabel: 'Delivery Guides',
      deliveryGuidesHelper: '{{count}} pending signature',
      tabQuotations: 'Quotations',
      tabReception: 'Reception Guides',
      tabDelivery: 'Delivery Guides',
      tabInvoices: 'Invoices',
      tabCreditNotes: 'Credit Notes',
      searchPlaceholder: 'Search document, client or code',
      locationPlaceholder: 'Filter by location',
      allLocations: 'All locations',
      openReceivables: 'Open Receivables',
      bulkCancel: 'Cancel ({{count}})',
      bulkRestoreDraft: 'Restore to Draft',
      exportSelected: 'Export',
      newQuotation: 'New Quotation',
      newClient: 'New Client',
      selectClient: 'Select Client',
      itemsAvailable: 'Items ({{count}} products available)',
      addItem: 'Add Item',
      addItemsHint: 'Add items to the quotation',
      vatRegime: 'VAT Regime:',
      vatIncluded: 'VAT Included',
      vatExcluded: 'VAT Excluded',
      exempt: 'Exempt',
      rate: 'Rate',
      subtotal: 'Subtotal',
      discounts: 'Discounts',
      taxableBase: 'Taxable Base',
      vat: 'VAT',
      total: 'Total',
      validity: 'Validity',
      location: 'Location',
      selectPlaceholder: 'Select...',
      additionalNotesPlaceholder: 'Additional notes...',
      createQuotation: 'Create Quotation',
      noQuotations: 'No quotation found',
      noReceptionGuides: 'No reception guide found',
      noDeliveryGuides: 'No delivery guide found',
      noServiceInvoices: 'No service invoice found',
      signed: 'Signed',
      pending: 'Pending',
      invoice: 'Invoice',
      service: 'Service',
      items: 'Items',
      convertQuotationTitle: 'Convert Quotation to Sale',
      documentType: 'Document Type',
      selectDocumentType: 'Select type',
      selectLocation: 'Select location',
      noItemsToConvert: 'No items to convert',
      productDescription: 'Product/Description',
      selectProduct: 'Select product...',
      itemDescriptionPlaceholder: 'Item description',
      price: 'Price',
      totalPreview: 'Total preview (without changing quotation history)',
      creditNotes: {
        title: 'Credit Notes',
        description: 'Track returns, reversals, and stock reconciliation with quick filters for status, origin, refund, and location.',
        newButton: 'Issue Credit Note',
        refreshButton: 'Refresh list',
        empty: 'No credit notes issued yet',
        filteredEmpty: 'No credit notes match the current filters',
        emptyHint: 'Use a sale or service invoice as the source to issue the first traceable credit note.',
        filters: {
          status: 'Status',
          refundMethod: 'Refund',
          origin: 'Origin',
          location: 'Location',
          allStatuses: 'All statuses',
          allRefundMethods: 'All refund methods',
          allOrigins: 'All origins',
          clear: 'Clear filters'
        },
        summary: {
          total: '{{count}} total',
          pending: '{{count}} pending',
          approved: '{{count}} approved',
          processed: '{{count}} processed',
          pendingActions: '{{count}} pending action',
          totalAmount: '{{amount}} in visible notes'
        },
        quickFilters: {
          pending: 'Pending',
          approved: 'Approved',
          customerCredit: 'Customer credit',
          saleOrigin: 'Sale origin',
          serviceOrigin: 'Service origin',
          clear: 'Clear filters'
        },
        activeFiltersLabel: 'Active filters',
        visibleResults: '{{count}} visible',
        columns: {
          number: 'CN #',
          originalDocument: 'Original Document',
          origin: 'Origin',
          customer: 'Customer',
          reason: 'Reason',
          amount: 'Amount',
          refund: 'Refund',
          status: 'Status',
          actions: 'Actions'
        },
        sourceTypes: {
          sale: 'Sale',
          service_invoice: 'Service Invoice'
        },
        refundMethods: {
          credit: 'Customer Credit',
          cash: 'Cash',
          bank_transfer: 'Bank Transfer',
          replacement: 'Replacement'
        },
        statuses: {
          pending: 'Pending',
          approved: 'Approved',
          processed: 'Processed',
          rejected: 'Rejected',
          cancelled: 'Cancelled'
        },
        actions: {
          approve: 'Approve',
          process: 'Process',
          pdf: 'PDF'
        },
        nextSteps: {
          approve: 'Next action: approve',
          process: 'Next action: process',
          done: 'Completed',
          review: 'No pending action'
        }
      }
    },
    migration: {
      title: 'Active Database Migration',
      description: 'Simplified export and import for the single-database architecture. Everything in this tab uses the system’s active database as the main reference.',
      primaryDb: 'Primary database',
      relatedDbs: 'Related databases',
      activePermissions: 'Active permissions',
      activeDatabase: 'System active database',
      activeDatabaseDescription: 'This is the default target used by the ERP and by every operation in this tab.',
      architectureLabel: 'Current architecture',
      singleDatabaseBadge: 'Single active database',
      singleDatabaseDescription: 'Legacy multi-database wording has been removed from this interface. Exports and imports always go through the same active context.',
      collectionsCount: '{{count}} collections detected',
      permissionsExport: 'export',
      permissionsImport: 'import',
      exportCardTitle: 'Export active database package',
      exportCardDescription: 'Creates a single ZIP package from the active database, including manifest and summary for backups, audits, or controlled migration.',
      exportContextLabel: 'Package context',
      exportContextDescription: 'The package is always generated from the system active database. The UI no longer exposes primary/related database choices.',
      scope: 'Scope',
      exportPrimaryOnly: 'Primary database only',
      exportAll: 'All relevant databases',
      generateExport: 'Generate export ZIP',
      importCardTitle: 'Import into the active database',
      importCardDescription: 'Accepts a full ZIP or multiple JSON files and applies them to the system active context without exposing legacy multi-database options.',
      importContextTitle: 'How this import works',
      importContextPrimary: 'Single destination: the system active database.',
      importContextSecondary: 'If you upload loose JSON files, the module automatically assumes the same logical context as the active database.',
      importContextDescription: 'The backend still receives the active database name, but the user no longer has to choose it in the UI.',
      targetDb: 'Target database',
      sourceDb: 'Source database (loose JSON)',
      files: 'ZIP/JSON files',
      filesSelected: '{{count}} file(s) selected',
      collectionsToImport: 'Collections to import',
      collectionsToImportHelp: 'If nothing is selected, the backend will use all collections available in the package.',
      clearWarning: '`clear` is manual and disabled by default. Only enable it when you are absolutely sure which collection should be wiped.',
      dryRun: 'Dry-run',
      importNow: 'Import now',
      refreshSummary: 'Refresh summary',
      latestOperation: 'Latest operation summary',
      latestOperationDescription: 'Shows the latest import/dry-run executed against the active database, including post-import validation when available.',
      historyTitle: 'Migration history',
      historyDescription: 'Track exports/imports for the active database and download the JSON report for each run.',
      downloadReport: 'Download report',
      noHistory: 'No operations have been recorded yet.',
      performedBy: 'Performed by',
      sourceDbLabel: 'Logical context',
      targetDbLabel: 'Active database',
      selectedCollections: 'Selected collections',
      clearCollections: 'Cleared collections',
      exportSuccess: 'Export package generated successfully',
      exportError: 'Failed to export data package',
      importSuccess: 'Import completed',
      dryRunSuccess: 'Dry-run completed',
      importError: 'Failed to import data',
      dryRunError: 'Dry-run failed',
      summaryError: 'Failed to load migration summary',
      historyError: 'Failed to load migration history',
      reportError: 'Failed to download report',
      reportSuccess: 'Report downloaded successfully',
      read: 'Read',
      inserted: 'Inserted',
      updated: 'Updated',
      ignored: 'Ignored',
      errors: 'Errors',
      searchPlaceholder: 'Search by user, package or file',
      filterAllOperations: 'All operations',
      noFilteredHistory: 'No operations match the current filters.',
      exportType: 'Export',
      importType: 'Import',
      dryRunType: 'Dry-run',
      validationVerifiable: 'Verifiable',
      validationMatched: 'Matched',
      validationMissing: 'Missing',
      validationUnverifiable: 'Unverifiable'
    },
    financialAnalysis: {
      title: 'Financial Analysis',
      description: 'Layout aligned to the technical cockpit: executive reading of operating profit, reconciliation of real costs, expenses/charges and stock health in the same panel.',
      badge: 'Costs + expenses',
      emptyTitle: 'No data available',
      emptyDescription: 'No financial records were found in this database. You can configure/import data to unlock the financial analysis.',
      profitCompliance: 'Profit compliance',
      profitComplianceDescription: 'The main profit on this page now uses the store view as the operational reference, which already considers real costs and recorded expenses/charges.',
      expensesAndCharges: 'Expenses & charges',
      operatingMargin: 'Operating margin',
      status: 'Status',
      expectedProfit: 'Profit within expected range',
      negativeProfit: 'Negative profit — review costs/expenses',
      totalRevenue: 'Total Revenue',
      totalCostExpenses: 'Costs + Expenses',
      operationalProfit: 'Operating Profit',
      staleStock: 'Stale Stock',
      productsCount: '{{count}} products',
      tiedCapital: 'Tied Capital',
      unitsCount: '{{count}} units',
      detailedIndicators: 'Detailed indicators',
      detailedIndicatorsDescription: 'More detail for executive reading: gross margin, net margin, average ticket, expense weight and revenue mix in the filtered period.',
      grossMargin: 'Gross margin',
      netMargin: 'Net margin',
      averageTicket: 'Average ticket',
      expenseWeight: 'Expense weight',
      consideredMoves: '{{count}} movements considered',
      quickComparisons: 'Quick comparisons',
      quickComparisonsDescription: 'Variation versus the previous period and profitability signal reading.',
      revenue: 'Revenue',
      netProfit: 'Net profit',
      expenses: 'Expenses',
      signal: 'Signal',
      serviceMix: 'Service mix',
      salesMix: 'Sales mix',
      monthlyTrend: 'Monthly trend',
      monthlyTrendDescription: 'Evolution over the last 6 months for revenue and net profit, with best and worst months highlighted.',
      bestMonth: 'Best month',
      watchMonth: 'Watch month',
      noData: 'No data',
      netMarginShort: 'Net margin',
      profitTab: 'Operating Profit',
      allocationTab: 'Allocation',
      employeesTab: 'By Employee',
      locationsTab: 'By Store',
      marginsTab: 'Margins',
      suppliersTab: 'Suppliers',
      stockTab: 'Stock Rotation',
      moduleCommercial: 'Sales / Commercial',
      moduleProjects: 'Projects',
      moduleRepairs: 'Technical Services',
      moduleKits: 'Kits / Bundles',
      moduleGaming: 'Gaming Center',
      modulePapelaria: 'Print Shop',
      signalHealthy: 'Healthy',
      signalWarning: 'Warning',
      signalCritical: 'Critical',
      profitByServiceTitle: 'Profit by service type',
      serviceRevenue: 'Revenue',
      partsCost: 'Parts Cost',
      sessionsCount: '{{count}} sessions',
      ordersCount: '{{count}} orders',
      simpleMargin: 'Margin: {{value}}%',
      profitByProductTitle: 'Profit by product (Top 10)',
      topProductsSummary: 'Revenue: {{revenue}} | Cost: {{cost}} | Profit: {{profit}}',
      partialReportTitle: 'Partial report: incomplete costs',
      partialReportFallback: 'There are items with partial/missing cost',
      noSalesInFilteredPeriod: 'No sales in this period',
      soldCount: '{{count}} sold',
      marginUnavailable: 'Margin unavailable',
      marginValue: '{{value}}% margin',
      allocationTitle: 'Allocation by module / category',
      allocationDescription: 'Revenue, direct cost, allocated expenses and operating profit by ERP vertical. The current rule combines direct expense by category and revenue-based proportional allocation.',
      directCost: 'Direct cost',
      allocatedExpenses: 'Allocated expenses',
      operationalProfitLabel: 'Operating profit',
      operationalMarginValue: 'Operational {{value}}%',
      inventoryModule: 'Inventory / Stock',
      capitalLabel: 'Capital tied',
      staleStockItems: 'Stock without sales',
      riskValue: 'Risk value',
      alertsLabel: 'Alerts',
      itemsLabel: '{{count}} items',
      expenseAllocationTitle: 'Allocated expenses by category',
      noAllocationRule: 'No rule available.',
      allocatedTotalsTitle: 'Allocated totals',
      totalRevenueLabel: 'Total revenue',
      totalCostLabel: 'Total cost',
      grossProfitLabel: 'Gross profit',
      employeesPerformanceTitle: 'Performance by employee',
      employeesPerformanceSummary: 'Total: {{profit}} profit | {{sales}} sales | {{services}} services',
      noActivityInPeriod: 'No activity in this period',
      salesAndServicesCount: '{{sales}} sales • {{services}} services',
      salesRevenue: 'Sales: {{value}}',
      servicesRevenue: 'Services: {{value}}',
      performanceAnalysisTitle: 'Performance Analysis:',
      bestPerformerLabel: 'Best:',
      performanceGapLabel: 'Performance gap:',
      storePerformanceTitle: 'Performance by store',
      drainingLocations: 'Stores draining cash: {{locations}}',
      noStoresFound: 'No stores found',
      salesShort: 'Sales',
      servicesShort: 'Services',
      expensesShort: 'Expenses',
      expectedVsActualMarginTitle: 'Expected vs actual margin',
      gapSummary: 'Gap: {{amount}} ({{percent}}%)',
      reportInfoTitle: 'Report information',
      minimumRequiredMarginLabel: 'Required minimum margin',
      minimumRequiredMarginHint: 'You can change it here in the UI. The value is also saved in `localStorage` (`financial-analysis-minimum-margin-pct`).',
      expectedProfitLabel: 'Expected Profit',
      realProfitLabel: 'Actual Profit',
      differenceLabel: 'Difference',
      currentMinimumMargin: 'Current required minimum margin: {{value}}%',
      underperformingProducts: '{{count}} products below expected margin',
      productsMarginDeviation: 'Products with margin deviation:',
      expectedLabel: 'Expected: {{value}}%',
      actualLabel: 'Actual: {{value}}%',
      deviationLabel: '{{value}}% deviation',
      supplierComparisonTitle: 'Supplier comparison',
      supplierComparisonDescription: 'Sorted by total purchase value',
      noSuppliersFound: 'No suppliers found',
      ordersAndProductsCount: '{{orders}} orders • {{products}} products',
      averageOrderValue: 'Average: {{value}}',
      stockAlertsTitle: 'Stock Alerts ({{count}})',
      criticalCount: 'Critical: {{count}}',
      highCount: 'High: {{count}}',
      mediumCount: 'Medium: {{count}}',
      highRotationTitle: 'High Rotation ({{count}})',
      highRotationDescription: 'Products with rotation ≥ 2x',
      noProductsLabel: 'No products',
      lowRotationTitle: 'Low Rotation ({{count}})',
      lowRotationDescription: 'Products with rotation < 0.5x',
      stockShort: 'Stock: {{count}}',
      staleProductsTitle: 'Stale Products (30+ days)',
      staleProductsDescription: '{{count}} products | Frozen value: {{value}}',
      noStaleProducts: 'No stale products',
      lastSaleLabel: 'Last sale: {{value}}',
      neverSold: 'Never sold',
      daysAgo: '{{count}} days',
      recommendationsTitle: 'Recommendations:',
      partialPanelsToast: 'Some Financial Analysis panels came back empty or unavailable, but the page was opened with partial data.',
      loadError: 'Failed to load financial data'
    },
    gamingCenter: {
      title: 'Gaming Center',
      description: 'Layout aligned to the technical cockpit: active sessions, daily revenue, console occupancy and next operational actions in one executive header.',
      badge: 'Gaming Experience',
      activeSessions: 'Active sessions',
      activeNow: 'Live now',
      sessionsToday: 'Sessions today',
      dailyService: 'Daily service',
      revenueToday: 'Revenue today',
      operatingRevenue: 'Operating revenue',
      freeConsoles: 'Free consoles',
      configuredCount: '{{count}} configured',
      configure: 'Configure',
      refresh: 'Refresh',
      loadingError: 'Failed to load Gaming Center data',
      partialConsolesError: 'Some Gaming Center data failed, but the page was opened with partial fallback.',
      emptyTitle: 'No gaming data available',
      emptyDescription: 'Add locations, payment methods or gaming services to start operating this module.',
      activeSessionsCard: 'Active Sessions',
      location: 'Location',
      employee: 'Employee',
      selectPlaceholder: 'Select',
      latestSession: 'Latest Session Created',
      start: 'START',
      end: 'END',
      duration: 'DURATION',
      paymentMethod: 'PAYMENT METHOD',
      printOriginal: 'Print POS (Original)',
      printDuplicate: 'Print POS (Duplicate)',
      viewInSales: 'View in Sales',
      consolesOccupancy: 'Consoles ({{busy}}/{{total}} busy)',
      reload: 'Reload',
      consoleLabel: 'Console {{number}}',
      inUse: 'In Use',
      stop: 'Stop',
      available: 'Available',
      clickToStart: 'Click to start',
      startSession: 'Start',
      recentSessions: 'Today\'s Sessions',
      noSessionsToday: 'No sessions recorded today'
    },
    salesPage: {
      title: 'Point of Sale',
      description: 'Cash operation, recent sales and quick payment control in a clearer header aligned with the rest of the ERP.',
      recentSales: 'Recent Sales',
      filteredPeriodRecords: 'Records in the filtered period',
      totalSold: 'Total Sold',
      aggregatedAmount: 'Aggregated amount in the period',
      cancelled: 'Cancelled',
      cancelledHelper: 'Cancelled sales',
      cart: 'Cart',
      cartHelper: 'Items in the current sale',
      cancelSelected: 'Cancel ({{count}})',
      restoreDraft: 'Restore to Draft',
      export: 'Export',
      newSale: 'New Sale',
      salesTab: 'Sales',
      cashTab: 'Integrated Cash',
      cancelledTab: 'Cancelled Sales',
      recentSalesTitle: 'Recent Sales ({{count}})',
      loadingSales: 'Loading sales...',
      noSales: 'No sales recorded',
      cashOperationalLocation: 'Operational POS/Cash Location',
      activeLocation: 'Active location',
      selectLocation: 'Select location',
      cancelledSalesTitle: 'Cancelled Sales ({{count}})',
      deleteCancelled: 'Delete Cancelled',
      noCancelledSales: 'No cancelled sales',
      details: 'Details',
      printCancelled: 'Print Cancelled',
      delete: 'Delete',
      posDialogTitle: 'New Sale',
      posDialogDescription: 'Select the location and add products to the cart',
      locationLabel: 'Location:',
      selectStoreLocation: 'Select store/location',
      sellingAt: 'Selling at: {{location}}',
      searchProduct: 'Search product...',
      selectLocationFirst: 'Select a location first',
      searchProductPlaceholder: 'Name, SKU, brand...',
      loadingProducts: 'Loading products...',
      noProductsFound: 'No products found',
      availableProducts: 'Available Products',
      includesComponents: 'Includes {{count}} components',
      availableItemsAt: 'Available items at:',
      noStockAtLocation: 'No stock in {{location}}',
      emptyCart: 'Cart is empty',
      employeeForSale: 'Employee responsible for the sale *',
      selectEmployee: 'Select employee',
      clientLabel: 'Client *',
      searchClient: 'Search client...',
      clientSearchPlaceholder: 'Name, tax ID, code...',
      noClientFound: 'No client found.',
      createClient: 'Create Client',
      indifferentClient: 'Walk-in Client',
      foundClients: 'Matching clients',
      quickClient: 'Quick Client',
      company: 'Company',
      individual: 'Individual',
      saleDiscount: 'Sale Discount',
      amountMt: 'Amount (MT)',
      paymentMethod: 'Payment Method *',
      selectAccount: 'Select account',
      paid: 'Paid',
      exactPaymentHint: 'Non-cash methods do not generate change; you can combine them with cash.',
      mixedPaymentCashHint: 'Change is calculated only on the cash portion.',
      fillRemaining: 'Fill remaining ({{amount}})',
      optionalNotes: 'Optional notes...',
      registeredAt: 'Registration Date/Time (optional)',
      createDraft: 'Create as draft',
      vatRegime: 'VAT Regime',
      vatIncluded: 'VAT Included',
      vatExcluded: 'VAT Excluded',
      exempt: 'Exempt',
      vatRateInfo: 'Rate: {{rate}}% | {{mode}}',
      priceIncludesVat: 'Price already includes VAT',
      vatWillBeAdded: 'VAT will be added',
      noVat: 'No VAT',
      subtotalGross: 'Gross Subtotal',
      itemDiscountShort: 'Item Disc.',
      saleDiscountShort: 'Sale Disc.',
      taxableBase: 'Taxable Base',
      totalUpper: 'TOTAL',
      totalCostPreview: 'Total Cost (preview)',
      totalProfitPreview: 'Total Profit (preview)',
      totalMarginPreview: 'Total Margin (preview)',
      unreliableMargin: 'Unreliable margin',
      unreliableMarginHint: 'Missing/incomplete cost data - review purchases/receipts',
      paidUpper: 'PAID',
      nonCashPaid: 'Paid without cash',
      cashPaid: 'Paid in cash',
      changeUpper: 'CHANGE',
      remaining: 'Remaining',
      nonCashOverflow: 'Non-cash overflow',
      differenceShouldBeZero: 'Difference (must be 0)',
      noOpenCash: 'No cash session is open in {{location}}. It is not possible to confirm the sale.',
      openCashNow: 'Open Integrated Cash Now',
      processing: 'Processing...',
      saveDraft: 'Save Draft',
      finalizeSale: 'Finalize Sale',
      cancelledDocument: 'Document',
      cancelledDatetime: 'Date/Time',
      cancelledBy: 'Cancelled by',
      cancelledReason: 'Reason',
      cancelledStock: 'Stock',
      actions: 'Actions',
      stockReturned: 'Returned',
      stockNotReturned: 'Not returned',
      lossSale: 'Sale with loss',
      belowMarginSale: 'You are selling below the minimum',
      negativeProfitConfirmation: 'Reinforced confirmation: sale with negative profit.',
      belowMarginConfirmation: 'Mandatory confirmation to finalize the sale below the minimum margin.',
      marginLabel: 'Margin',
      minimumShort: 'min.',
      salePrice: 'Sale price',
      minimumPrice: 'Minimum price',
      difference: 'Difference',
      profit: 'Profit',
      quantity: 'Quantity',
      lineTotal: 'Line total',
      supervisorApprovalRequired: 'Supervisor/manager approval required. Enter PIN to authorize.',
      authorizerName: 'Authorizer name *',
      selectAuthorizer: 'Select the authorizer',
      loadingAuthorizers: 'Loading authorizers...',
      authorizerRequired: 'Select the user who will authorize this sale.',
      authorizerInvalid: 'The selected user can no longer authorize this sale.',
      authorizerPinNotConfigured: 'The selected user does not have a configured PIN.',
      authorizerRolesHelp: 'Authorized roles: Supervisor, Manager and Administrator.',
      authorizerSelectedHelp: 'This authorization will be recorded under {{name}}.',
      noCommercialAuthorizersConfigured: 'There is no authorized user with a configured PIN right now.',
      commercialPinRequired: 'Commercial PIN is required.',
      invalidCommercialPin: 'Invalid PIN.',
      commercialPinRateLimit: 'Too many PIN attempts. Please try again later.',
      saleAuthorizedBy: 'Sale authorized by {{name}}.',
      lossSaleStrong: 'Sale with loss.',
      reinforcedConfirmationRequired: 'Reinforced confirmation required.',
      supervisorPin: 'Supervisor PIN *',
      enterPin: 'Enter PIN',
      understandLoss: 'I understand the loss',
      overrideReason: 'Override reason *',
      describeOverrideReason: 'Describe the override reason',
      goBackAdjust: 'Go back and adjust',
      finalizeAnyway: 'Finalize anyway',
      insufficientStock: 'Insufficient stock',
      lossConfirmationRequired: 'Loss confirmation is required',
      overrideReasonRequired: 'Override reason is required (minimum 5 characters)',
      printDocumentOpened: 'Document opened for printing',
      printCancelledOpened: 'CANCELLED document opened for printing',
      adminCancelled: 'Sale cancelled by administrator!',
      adminCancelledStock: 'Sale cancelled by administrator - Stock returned!',
      saleCancelled: 'Sale cancelled!',
      saleCancelledStock: 'Sale cancelled - Stock returned!',
      cancellationReasonRequired: 'Cancellation reason is required',
      selectLocationBeforeScan: 'Select a location before scanning',
      saleFromQuote: 'Sale originated from quote {{reference}}',
      saleFromProject: 'Sale originated from project {{reference}}',
      purgedCancelledSales: 'Cancelled sales deleted ({{count}})',
      selectLocationFirstShort: 'Select a location first',
      selectLocationBeforeProducts: 'Select a location before adding products',
      selectAccountAndAmount: 'Select the account and enter the amount',
      selectLocationForSale: 'Select a location for the sale',
      selectEmployeeForSale: 'Select the employee who made the sale',
      selectClientForSale: 'Select a client, create one, or use Walk-in Client',
      employeeNotFound: 'Employee not found',
      draftCreated: 'Sale draft created!',
      saleCompletedAt: 'Sale completed at {{location}}!',
      updateCompleted: 'Sale updated!',
      saleAlreadyCancelled: 'Sale is already cancelled',
      saleConfirmed: 'Sale confirmed!',
      saleMarkedPaid: 'Sale marked as paid!',
      saleConcluded: 'Sale completed!',
      selectSalesBulkAction: 'Select sales for bulk action',
      selectSalesExport: 'Select sales to export',
      saleNumber: 'Sale No.',
      employeeShort: 'Employee',
      statusShort: 'Status',
      statusLabel: 'Status',
      locationShort: 'Location',
      customerCode: 'Code',
      openReceivable: 'Open Receivable',
      originatedQuote: 'Originated from Quote:',
      originatedProject: 'Originated from Project:',
      itemsSection: 'Items',
      productLabel: 'Product',
      qtyLabelShort: 'Qty',
      priceLabel: 'Price',
      discountLabelShort: 'Disc.',
      costLabel: 'Cost',
      profitLabelShort: 'Profit',
      marginLabelShort: 'Margin',
      paymentSection: 'Payment Method',
      paymentFormLine: 'Payment Method:',
      subtotal: 'Subtotal',
      itemsDiscount: 'Items Discount',
      saleDiscountWithPct: 'Sale Discount ({{pct}}%)',
      totalCost: 'Total Cost',
      totalProfit: 'Total Profit',
      totalMargin: 'Total Margin',
      printOptions: 'Print Options',
      printCancelledDocument: 'Print CANCELLED Document',
      invoice: 'Invoice',
      deliveryGuide: 'Guide',
      newClientTitle: 'New Client',
      newClientDescription: 'Create a client and automatically link it to the sale.',
      nameRequired: 'Name *',
      taxId: 'Tax ID',
      typeLabel: 'Type',
      addressLabel: 'Address',
      cityLabel: 'City',
      contactPerson: 'Contact Person',
      creating: 'Creating...',
      editSaleTitle: 'Edit Sale - {{sale}}',
      changesTracked: 'Changes are recorded in the history.',
      customerNameLabel: 'Customer Name',
      customerBlockTitle: 'Customer and identification',
      customerBlockDescription: 'Update the commercial data linked to the sale.',
      editableProjectValues: 'Editable values from project-generated sale',
      editableProjectValuesDesc: 'You can adjust only quantities, prices and discounts for lines in this draft sale.',
      editSaleFullAccess: 'Admin/Manager can revise lines, payments, discounts and customer data in a single edit flow.',
      editSaleItemsTitle: 'Sale lines',
      editSaleItemsDescription: 'Edit quantities, prices, discounts, description and VAT without leaving the sale.',
      editSaleFinancialTitle: 'Financial data',
      editSaleFinancialDescription: 'Review employee, sale discounts and totals recalculated in real time.',
      editSalePaymentsDescription: 'Adjust the payment composition so the sale stays consistent with the new total.',
      editSaleComputedTotal: 'New total',
      addPaymentLabel: 'Add',
      noAdditionalDescription: 'No additional description',
      valueDiscount: 'Discount amount',
      percentDiscount: 'Discount %',
      justificationRequiredLabel: 'Justification *',
      changeReasonPlaceholder: 'Reason for the change...',
      save: 'Save',
      purgeCancelledTitle: 'Delete cancelled sales',
      purgeOneDescription: 'This action permanently removes the cancelled sale {{sale}} and all linked records.',
      purgeAllDescription: 'This action permanently removes all cancelled sales and all linked records.',
      deleting: 'Deleting...',
      confirmDelete: 'Confirm deletion',
      confirmChangeTitle: 'Confirm Change',
      changeWillBeTracked: 'This change will be recorded in history.',
      cancelSaleTitle: 'Cancel Sale',
      returnItemsToStock: 'Return items to stock',
      additionalNotes: 'Additional notes',
      cancellationReasonPlaceholder: 'Reason for cancellation...',
      additionalNotesPlaceholder: 'Optional notes about the cancellation',
      back: 'Back',
      historyTitle: 'History - {{sale}}',
      noRecords: 'No records',
      createdStatus: 'Created',
      editedStatus: 'Edited',
      confirmedStatus: 'Confirmed',
      paidStatus: 'Paid',
      completedStatus: 'Completed',
      cancelledStatus: 'Cancelled',
      reasonLabel: 'Reason:',
      justificationLabel: 'Justification:',
      emptyTitle: 'No sales data available',
      emptyDescription: 'Configure locations, payment accounts and products to start operating the POS.',
      partialData: 'Some sales blocks came back with partial fallback, but the POS loaded with the available data.',
      loadError: 'Failed to load sales data'
    },
    moduleState: {
      partialTitle: 'Data loaded with partial fallback',
      partialDescription: 'Some optional requests failed, but the module still opened and now shows exactly what became unavailable.',
      blockingTitle: 'Critical loading failures detected',
      blockingDescription: 'One or more required endpoints failed. The module no longer hides the real cause of the problem.',
      issueTimeout: 'API timeout',
      issueHttp: 'HTTP {{status}}',
      issueCritical: 'critical failure',
      issueFallback: 'fallback activated',
      unknownEndpoint: 'unknown endpoint',
      moreIssues: '+{{count}} additional issue(s)'
    },
    // Alerts
    alerts: {
      title: 'Alerts Central',
      subtitle: 'Centralized management of all alerts',
      overview: 'Overview',
      followups: 'Follow-ups',
      debtors: 'Debtors',
      fixedPayments: 'Fixed Payments',
      pettyCash: 'Petty Cash',
      suppliers: 'Suppliers',
      warranties: 'Warranties',
      licenses: 'Licenses',
      allAlerts: 'All Alerts',
      totalActive: 'Total Active',
      critical: 'Critical',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
      newFollowup: 'New Follow-up',
      newFixedPayment: 'New Fixed Payment',
      recordExpense: 'Record Expense',
      replenishFund: 'Replenish Fund',
      markPaid: 'Mark Paid',
      resolve: 'Resolve',
      clientName: 'Client Name',
      contactPhone: 'Contact Phone',
      followupDate: 'Follow-up Date',
      reason: 'Reason',
      paymentName: 'Payment Name',
      paymentCategory: 'Category',
      paymentAmount: 'Amount',
      paymentFrequency: 'Frequency',
      dueDay: 'Due Day',
      expenseDescription: 'Expense Description',
      expenseCategory: 'Category',
      daysOverdue: 'days overdue',
      dueThisWeek: 'Due this week',
      noAlerts: 'No alerts',
      noCriticalAlerts: 'No critical alerts',
      noDebtors: 'No active debts',
      noFollowups: 'No pending follow-ups',
      noFixedPayments: 'No fixed payments',
      noPettyCash: 'No petty cash configured',
      strategicControl: 'Strategic control of all critical operations',
      fixedPaymentsThisWeek: 'Fixed Payments',
      thisWeek: 'This week',
      criticalAlerts: 'Critical Alerts',
      noPendingPayments: 'No pending payments',
      emptyTitle: 'No alerts available',
      emptyDescription: 'Alerts Central opened without data. You can configure/import data and try again.',
      loadError: 'Failed to load alerts',
      resolveSuccess: 'Alert resolved',
      resolveError: 'Failed to resolve alert',
      requiredFields: 'Fill in the required fields',
      followupCreated: 'Follow-up created successfully',
      followupError: 'Failed to create follow-up',
      fixedPaymentCreated: 'Fixed payment created',
      fixedPaymentError: 'Failed to create fixed payment',
      paymentRegistered: 'Payment recorded',
      paymentRegisterError: 'Failed to record payment',
      expenseRecorded: 'Expense recorded',
      expenseRecordError: 'Failed to record expense',
      fundReplenished: 'Fund replenished',
      fundReplenishError: 'Failed to replenish fund',
      activeAlertFallback: 'Alert',
      unknownValue: 'N/A',
      nextDays: 'Next {{count}} days',
      noLicensesExpiring: 'No licenses expiring in the next {{count}} days',
      noWarrantiesExpiring: 'No warranties expiring in the next {{count}} days',
      licensesTitle: 'License Alerts',
      warrantiesTitle: 'Warranty Alerts',
      expiresOn: 'Expires: {{date}}',
      daysRemaining: '{{count}} days left',
      followupRequestsTitle: 'Contact Requests',
      newFollowupButton: 'New Follow-up',
      call: 'Call',
      resolved: 'Resolved',
      debtorsTitle: 'Debtor Clients',
      saleLabel: 'Sale: {{value}}',
      fromAmount: 'of {{value}}',
      fixedPaymentsTitle: 'Fixed Payments',
      noFixedPaymentsConfigured: 'No fixed payments configured',
      nextDue: 'Next: {{date}}',
      markPaidButton: 'Mark Paid',
      pettyCashTitle: 'Petty Cash',
      recordExpenseButton: 'Record Expense',
      ofAmount: 'of {{value}}',
      replenishFundButton: 'Replenish Fund',
      supplierDebtsTitle: 'Supplier Debts',
      noSupplierDebts: 'No supplier debts',
      poLabel: 'PO: {{value}}',
      dueDateLabel: 'Due: {{date}}',
      allActiveAlertsTitle: 'All Active Alerts',
      noActiveAlerts: 'No active alerts',
      followupDialogTitle: 'New Follow-up',
      fixedPaymentDialogTitle: 'New Fixed Payment',
      payFixedDialogTitle: 'Mark Payment as Paid',
      expenseDialogTitle: 'Record Petty Cash Expense',
      replenishDialogTitle: 'Replenish Petty Cash',
      followupNamePlaceholder: 'Client name',
      followupReasonPlaceholder: 'Ex: Client asked to be called tomorrow',
      fixedPaymentNamePlaceholder: 'Ex: Maputo Store Rent',
      expenseLocationPlaceholder: 'Select location',
      expenseDescriptionPlaceholder: 'Ex: Goods transport',
      replenishAmountLabel: 'Amount to Replenish (MZN)',
      currentBalance: 'Current balance: {{value}}',
      totalFund: 'Total fund: {{value}}',
      confirmPayment: 'Confirm Payment',
      createFixedPayment: 'Create',
      createFollowup: 'Create Follow-up',
      categoryRent: 'Rent',
      categoryWater: 'Water',
      categoryElectricity: 'Electricity',
      categoryInternet: 'Internet',
      categorySalary: 'Salary',
      categoryOther: 'Other',
      frequencyMonthly: 'Monthly',
      frequencyWeekly: 'Weekly',
      frequencyQuarterly: 'Quarterly',
      frequencyYearly: 'Yearly',
      expenseCategoryTransport: 'Transport',
      expenseCategoryMaintenance: 'Maintenance',
      expenseCategorySupplies: 'Supplies',
      expenseCategoryOther: 'Other',
      paymentMethodCash: 'Cash',
      paymentMethodMpesa: 'M-Pesa',
      paymentMethodEmola: 'E-MOLA',
      paymentMethodTransfer: 'Transfer'
    },
    // Services
    services: {
      title: 'Services',
      repairs: 'Repairs',
      gaming: 'Gaming Center',
      papelaria: 'Print Shop',
      others: 'Others',
      newService: 'New Service',
      serviceNumber: 'Service #',
      customer: 'Customer',
      device: 'Device',
      issue: 'Issue',
      diagnosis: 'Diagnosis',
      status: 'Status',
      technician: 'Technician',
      estimatedTime: 'Estimated Time',
      cost: 'Cost',
      pending: 'Pending',
      reception: 'In Reception',
      inProgress: 'In Progress',
      awaitingParts: 'Awaiting Parts',
      awaitingApproval: 'Awaiting Approval',
      readyForPickup: 'Ready for Pickup',
      completed: 'Completed',
      cancelled: 'Cancelled'
    },
    whatsappPage: {
      subtitle: 'Notifications and messaging center via WhatsApp',
      connected: 'Connected',
      disconnected: 'Disconnected',
      sandbox: 'Sandbox',
      emptyTitle: 'WhatsApp without initial data',
      emptyDescription: 'Check connection, history, and sandbox so the channel stays operational without relying on legacy flows.',
      emptyCta: 'Refresh channel',
      stats: {
        sent: 'Messages Sent',
        delivered: 'Delivered',
        failed: 'Failed',
        templates: 'Available Templates'
      },
      tabs: {
        send: 'Send Message',
        templates: 'Templates',
        history: 'History'
      },
      selectTemplateTitle: 'Select Template',
      selectTemplateDescription: 'Choose a predefined template to send',
      sendMessageTitle: 'Send Message',
      sendMessageDescription: 'Fill in the details and send the message',
      phoneLabel: 'Phone Number',
      phoneHint: 'Format: +258XXXXXXXXX (with country code)',
      templatePrefix: 'Template',
      customMessageLabel: 'Or send a custom message',
      customMessagePlaceholder: 'Type your message here...',
      sending: 'Sending...',
      sendTemplate: 'Send Template',
      sendCustom: 'Send Custom',
      templatesTitle: 'Available Templates',
      templatesDescription: 'View all configured message templates',
      historyTitle: 'Message History',
      historyDescription: 'Last {{count}} messages sent',
      refresh: 'Refresh',
      noHistory: 'No messages sent yet',
      sendFirstMessage: 'Send First Message',
      sandboxTitle: 'Sandbox Configuration',
      sandboxDescription: 'To test messages, first register your number in the Twilio Sandbox.',
      howToRegister: 'How to register:',
      sandboxStep1: '1. Open WhatsApp on your phone',
      sandboxStep2: '2. Send the message',
      sandboxStep3: '3. To the number',
      sandboxStep4: '4. Wait for Twilio confirmation',
      qrHint: 'Scan the QR code or send the message manually',
      testSend: 'Test Send',
      status: {
        sent: 'Sent',
        delivered: 'Delivered',
        read: 'Read',
        failed: 'Failed',
        queued: 'Queued'
      },
      templates: {
        warranty_accepted: { name: 'Warranty Accepted', description: 'Notify client that the warranty was approved' },
        warranty_rejected: { name: 'Warranty Rejected', description: 'Inform that the warranty expired with a quote' },
        warranty_void: { name: 'Warranty Voided', description: 'Notify damage not covered by warranty' },
        sale_completed: { name: 'Sale Completed', description: 'Purchase confirmation with details' },
        repair_received: { name: 'Device Received', description: 'Confirm reception for repair' },
        repair_in_progress: { name: 'Repair in Progress', description: 'Repair progress update' },
        repair_completed: { name: 'Repair Completed', description: 'Notify completion and ready for pickup' }
      }
    },
    papelariaPage: {
      title: 'Print Shop Services',
      description: 'Top area reorganized with a cockpit-style reading: daily volume, revenue, processed items, and operational parameters in one view.',
      badge: 'Print Shop',
      freeLabel: 'Free',
      selectPlaceholder: 'Select',
      emptyTitle: 'Print shop without initial data',
      emptyDescription: 'Configure services, location, and payment methods to avoid total failures at the print shop counter.',
      emptyCta: 'Open Settings',
      availableServices: 'Available Services',
      availableServicesDescription: 'Click to add to cart',
      cartTitle: 'Cart ({{count}})',
      emptyCart: 'Empty cart',
      customerOptional: 'Customer (optional)',
      customerPlaceholder: 'Customer name',
      payment: 'Payment',
      otherPayments: 'Others...',
      datetimeOptional: 'Date/Time (optional)',
      total: 'Total',
      processing: 'Processing...',
      finishSale: 'Finish Sale',
      recentSales: 'Recent Sales',
      noRecentSales: 'No sales recorded today',
      stats: {
        salesToday: 'Sales today',
        revenueToday: 'Revenue today',
        location: 'Location',
        employee: 'Employee',
        itemsHelper: '{{count}} items',
        revenueHelper: 'Operational revenue',
        locationHelper: 'Focused store',
        employeeHelper: 'Current service'
      }
    },
    globalFilters: {
      periods: {
        allTime: 'All Time',
        today: 'Today',
        yesterday: 'Yesterday',
        thisWeek: 'This Week',
        thisMonth: 'This Month',
        lastMonth: 'Last Month',
        thisYear: 'This Year',
        lastYear: 'Last Year',
        custom: 'Custom'
      },
      deleted: {
        active: 'Active',
        deleted: 'Deleted',
        all: 'All'
      },
      selectDates: 'Select dates',
      selectPeriod: 'Select period',
      from: 'From',
      to: 'To',
      apply: 'Apply',
      location: 'Location',
      allLocations: 'All Locations',
      employee: 'Employee',
      allEmployees: 'All Employees',
      status: 'Status',
      allStatuses: 'All Statuses',
      category: 'Category',
      allCategories: 'All Categories',
      account: 'Account',
      allAccounts: 'All Accounts',
      activeFilters: '{{count}} filter',
      clearFilters: 'Clear filters'
    },
    cashManagementPage: {
      title: 'Cash Management',
      description: 'Sessions, transfers, and balance control',
      posCash: 'POS Cash',
      posSales: 'POS Sales',
      selectLocation: 'Select Location',
      searchPlaceholder: 'Search code, location, reason, or account',
      searchHint: 'Quick search applies to the current tab for faster daily operations.',
      emptyTitle: 'Cash management without initial data',
      emptyDescription: 'Configure locations, payment accounts, and operation types to start recording sessions and transfers.',
      emptyCta: 'Open Settings',
      opening: 'Opening',
      closing: 'Closing',
      difference: 'Difference',
      type: 'Type',
      sourceDestination: 'Source → Destination',
      reason: 'Reason',
      pendingAlertsCount: '{{count}} pending alert',
      newTransfer: 'New Transfer',
      registerCheckpoint: 'Register Checkpoint',
      refresh: 'Refresh',
      tabs: { sessions: 'Sessions', transfers: 'Transfers', alerts: 'Alerts' },
      noSessions: 'No sessions recorded',
      noTransfers: 'No transfers recorded',
      systemAlerts: 'System Alerts',
      pendingBadge: '{{count}} pending',
      alertFilters: { open: 'Open', resolved: 'Resolved', invalidScope: 'Invalid scope', staleHistory: 'Stale history', all: 'All' },
      noOpenAlerts: 'No pending alerts',
      noResolvedAlerts: 'No resolved alerts',
      noAlerts: 'No alerts recorded',
      resolve: 'Resolve',
      viewAlerts: 'View alerts',
      openSessionForAlert: 'Open session',
      archivedBatch: 'Batch',
      archivalReason: 'Rule',
      archivedAt: 'Archived at',
      selectedLocationFocus: 'Focus on current location',
      selectedLocationAlerts: '{{count}} alerts in this location',
      dailyCockpitTitle: 'Daily cockpit',
      dailyCockpitDescription: 'Fast reading for opening, closing, pending items, and isolated history.',
      operationalCards: {
        sessionState: 'Operational state',
        activeAlerts: 'Active pending items',
        archivedAlerts: 'Isolated history',
        movements: 'Period movement',
        noLocation: 'Choose a location to operate',
        noSession: 'No open session',
        sessionOpen: 'Session open',
        pendingOpening: 'Opening pending',
        activeAlertsHelper: '{{count}} alerts require practical action',
        archivedAlertsHelper: '{{count}} alerts preserved outside the active layer',
        sessionsHelper: '{{count}} sessions in the period',
        checkpointsHelper: '{{count}} checkpoints recorded',
        openAlertsAction: 'Open pending items',
        openArchivedAction: 'View history',
        openSessionAction: 'Open session',
        noImmediateAction: 'No immediate action'
      },
      openSessionTitle: 'Open Cash Session',
      openSessionAction: 'Open Session',
      closeSessionTitle: 'Close Cash Session',
      closeSessionAction: 'Close Session',
      transferDialogTitle: 'New Transfer (TRF)',
      transferDialogDescription: 'Register a new cash operation, transfer, or withdrawal with full traceability.',
      registerTransfer: 'Register Transfer',
      checkpointDialogTitle: 'Register Checkpoint',
      checkpointDialogDescription: 'Record an intermediate balance check to strengthen operational control.',
      resolveAlertTitle: 'Resolve Alert',
      confirmResolution: 'Confirm Resolution',
      sessionDetailsTitle: 'Session Details',
      transferDetailsTitle: 'Transfer Details',
      openedBy: 'Opened by',
      entries: 'Entries',
      exits: 'Exits',
      expenses: 'Expenses',
      justification: 'Justification',
      closedByAt: 'Closed by {{name}} at {{date}}',
      sourceAccount: 'Source Account',
      destinationAccount: 'Destination Account',
      attachments: 'Attachments',
      registeredByAt: 'Recorded by {{name}} on {{date}}',
      resolutionComment: 'Resolution Comment',
      resolutionPlaceholder: 'Explain how the alert was resolved or justify the situation...',
      resolutionHint: 'The comment is mandatory and will be recorded in the system history.',
      checkpointInfo: 'Checkpoints are periodic cash balance checks to ensure control.',
      sessionLabel: 'Session',
      noActiveSession: 'No open session',
      openSessionHint: 'Open a session to record operations',
      sessionOpenedBy: 'Opened at {{date}} by {{name}}',
      expectedBalance: 'Expected Balance',
      openingBalance: 'Opening Balance',
      filters: {
        allSessionStatuses: 'All session statuses',
        allDirections: 'All directions',
        allOperationTypes: 'All operation types',
        allAlertTypes: 'All alert types'
      },
      sessionSummary: {
        open: '{{count}} open',
        closed: '{{count}} closed',
        pending: '{{count}} pending'
      },
      transferSummary: {
        in: '{{count}} incoming',
        out: '{{count}} outgoing',
        transfer: '{{count}} transfers'
      },
      alertSummary: {
        missedCheckpoint: '{{count}} missed checkpoints',
        noOpening: '{{count}} no opening',
        noClosing: '{{count}} no closing'
      },
      statusLabels: {
        open: 'Open',
        closed: 'Closed',
        pending_reconciliation: 'Pending'
      },
      directionLabels: {
        in: 'Incoming',
        out: 'Outgoing',
        transfer: 'Transfer'
      },
      severityLabels: {
        critical: 'Critical',
        high: 'High',
        warning: 'Warning',
        medium: 'Medium',
        low: 'Low'
      },
      alertStatusLabels: {
        open: 'Active',
        resolved: 'Resolved',
        invalid_scope: 'Invalid scope',
        stale_history: 'Stale history'
      },
      archivalReasonLabels: {
        invalid_location_scope: 'Invalid by scope',
        stale_past_day: 'Past-day stale'
      },
      alertTypes: {
        open: 'Open',
        resolved: 'Resolved',
        all: 'All',
        missedCheckpoint: 'Missing Checkpoint',
        noOpening: 'Session not Opened',
        noClosing: 'Session not Closed'
      },
      closeSessionDescription: 'Enter the closing balance and justify any differences if needed.',
      transferDetailsDescription: 'Full details of the cash transfer.',
      resolveAlertDescription: 'Add a comment to resolve this alert.'
    },
    catalogsPage: {
      expenseCategoriesTitle: 'Expense Categories (PGT)',
      newCategory: 'New Category',
      repairTypesTitle: 'Repair Types (SR)',
      newType: 'New Type',
      cashOpsTitle: 'Cash Operations (TRF)',
      resetCashOps: 'Restore Base TRF',
      noCashOps: 'No visible TRF operations at the moment.',
      noCashOpsHelp: 'Use the base restore to get ready-to-use operation types back whenever needed.'
    },
    procurementPage: {
      title: 'Procurement Management',
      description: 'Manage suppliers and purchase orders',
      stockTransfers: 'Transfers',
      services: 'Services',
      searchPlaceholder: 'Search...',
      emptyTitle: 'Procurement without initial data',
      emptyDescription: 'Add suppliers and base products so the module stays operational even when part of the legacy stack fails.',
      emptyCta: 'Open Inventory',
      tabs: {
        purchaseOrders: 'Purchase Orders',
        suppliers: 'Suppliers',
        deletedSuppliers: 'Deleted Suppliers',
        cancelledPOs: 'Cancelled POs'
      },
      newPO: 'New Purchase Order',
      clearSelection: 'Clear selection',
      selectVisible: 'Select visible',
      approve: 'Approve',
      receive: 'Receive',
      configurableXlsx: 'Configurable XLSX',
      loadingPOs: 'Loading purchase orders...',
      noPOs: 'No purchase orders',
      addSupplier: 'Add Supplier',
      loadingSuppliers: 'Loading suppliers...',
      noSupplierFound: 'No supplier found',
      noSuppliers: 'No suppliers yet. Add the first one!',
      deletedSuppliersTitle: 'Deleted Suppliers ({{count}})',
      noDeletedSuppliers: 'No deleted suppliers',
      deletedAtBy: 'Deleted on {{date}} by {{name}}',
      cancelledPOsTitle: 'Cancelled Purchase Orders ({{count}})',
      noCancelledPOs: 'No cancelled purchase orders',
      cancelledAt: 'Cancelled at',
      cancelledBy: 'Cancelled by',
      reasonLabel: 'Reason',
      exportDialogTitle: 'Export POs to XLSX',
      exportDialogDescription: 'Choose which columns should be included in the selected purchase orders file.',
      bulkCancelTitle: 'Bulk cancel purchase orders',
      bulkCancelDescription: 'Provide the reason to cancel the selected POs. The system automatically ignores POs that can no longer be cancelled.',
      bulkCancelPlaceholder: 'Reason for bulk cancellation',
      confirmCancellation: 'Confirm cancellation',
      addSupplierTitle: 'Add New Supplier',
      supplierName: 'Supplier Name',
      contactPerson: 'Contact Person',
      taxId: 'Tax ID/NUIT',
      address: 'Address',
      city: 'City',
      paymentTerms: 'Payment Terms',
      paymentTermsPlaceholder: 'Ex: Net 30, Cash on delivery'
    },
    rolesPermissionsPage: {
      title: 'System roles',
      description: 'Module-based organization including base roles and created roles, making access adjustments easier.',
      hideDeleted: 'Hide deleted',
      showDeleted: 'Show deleted',
      newRole: 'New Role',
      rolesCount: '{{count}} role(s) integrated · {{modules}} modules recognized',
      loadingRoles: 'Loading roles...',
      noRoles: 'No roles found.',
      assignmentTitle: 'Role assignment',
      assignmentDescription: 'Assign a configurable role to each user without losing the system base role.',
      loadingUsers: 'Loading users...',
      noUsers: 'No users found.'
    },
    notificationBell: {
      title: 'Notifications',
      disabled: 'Notifications disabled',
      enabled: 'Notifications enabled!',
      enableError: 'Failed to enable notifications',
      preferencesSaved: 'Preferences saved',
      preferencesError: 'Failed to save preferences',
      enableDescription: 'Enable notifications to receive critical system alerts.',
      enableBrowser: 'Enable Browser Notifications',
      blockedWarning: '⚠️ Notifications blocked. Check your browser settings.',
      noPending: 'No pending alerts',
      viewAllAlerts: 'View All Alerts',
      preferencesTitle: 'Notification Preferences',
      preferencesDescription: 'Choose which critical alerts you want to receive.',
      pushTitle: 'Push Notifications',
      pushDescription: 'Receive alerts in the browser',
      checkpointDescription: 'Alerts for unregistered checkpoints',
      sessionDescription: 'Session opening/closing alerts',
      varianceDescription: 'Variance alerts > 1 MZN',
      saving: 'Saving...',
      savePreferences: 'Save Preferences'
    },
    salesCashPanel: {
      title: 'POS + Integrated Cash',
      description: 'Sales and cash share the same operational location. Without an open session, confirmed sale is not allowed.',
      selectLocationError: 'Select a location to open the cash session',
      invalidOpeningBalance: 'Invalid opening balance',
      sessionOpened: 'Cash session opened successfully',
      openError: 'Failed to open cash session',
      noActiveSession: 'There is no active session to close',
      invalidClosingBalance: 'Invalid closing balance',
      sessionClosed: 'Cash session closed successfully',
      closeError: 'Failed to close cash session',
      sessionOpen: 'Session Open',
      sessionClosedLabel: 'Session Closed',
      noLocationSelected: 'No location selected',
      openingBalance: 'Opening Balance',
      sessionSales: 'Session Sales',
      openedAt: 'Opened at',
      noSessionForLocation: 'No cash session open for this location.',
      openIntegratedCash: 'Open Integrated Cash',
      closeCash: 'Close Cash',
      openCashCenter: 'Open Cash Center',
      openDialogTitle: 'Open Cash Session',
      openDialogDescription: 'The session will be opened for {{location}}.',
      selectedLocationFallback: 'the selected location',
      opening: 'Opening...',
      confirmOpen: 'Confirm opening',
      closeDialogTitle: 'Close Cash Session',
      closeDialogDescription: 'Enter the final counted balance to complete the closing.',
      closingBalance: 'Closing balance',
      differenceJustification: 'Difference justification (if any)',
      closingNotes: 'Closing notes',
      closing: 'Closing...',
      confirmClose: 'Confirm closing'
    },
    vatConfigPage: {
      title: 'VAT Configuration',
      description: 'Configure the default VAT rate and regime for the system (Mozambique: 16%)',
      loadError: 'Failed to load VAT configuration',
      saveSuccess: 'VAT configuration updated successfully!',
      saveError: 'Failed to save configuration',
      calculateError: 'Failed to calculate VAT',
      rulesTitle: 'Mandatory VAT Rules',
      defaultRate: 'Default VAT Rate (%)',
      mozRate: 'Mozambique: 16%',
      defaultRateHint: 'Default rate applied to new products and documents',
      defaultRegime: 'Default VAT Regime',
      selectRegime: 'Select regime',
      defaultRegimeHint: 'Defines whether prices include or exclude VAT by default',
      quickPresets: 'Quick presets',
      impactPreview: 'Default impact (preview)',
      impactDescription: 'For a base value of {{value}}, the system will apply by default:',
      saving: 'Saving...',
      saveButton: 'Save Configuration',
      calculatorTitle: 'VAT Calculator',
      calculatorDescription: 'Test VAT calculation with the current configuration',
      testPrice: 'Test Price (MT)',
      calculateButton: 'Calculate',
      currentConfig: 'Current Configuration'
    },
    serialNumbersPanel: {
      title: 'Serial Numbers',
      summary: '{{product}} • {{count}} records',
      addShort: 'Add SN',
      searchPlaceholder: 'Search IMEI or serial number...',
      identifier: 'Identifier',
      stateLocation: 'State / Location',
      details: 'Details',
      empty: 'No serial numbers found'
    },
    welcomeTour: {
      stepCounter: 'Step {{current}} of {{total}}',
      skip: 'Skip Tour',
      finish: 'Finish',
      steps: {
        welcome: { title: 'Welcome to CG Business ERP!', content: 'This tour will present the main system features adapted to the {{profileName}} profile.' },
        dashboard: { title: 'Main Dashboard', content: 'The dashboard presents KPIs, charts, and business metrics in real time. Here you can monitor sales, expenses, and performance.' },
        sales: { title: 'Sales / POS', content: 'The sales module supports 16% VAT, multiple payment methods, and fiscal document printing.' },
        inventory: { title: 'Inventory Management', content: 'Control products, stock by location, IMEI/serial tracking, and low-stock alerts.' },
        clients: { title: 'Client Management', content: 'Complete CRM with purchase history, alerts, and credit management.' },
        services: { title: 'Services and Repairs', content: 'Register repairs, diagnostics, quotations, and track the status of each service.' },
        projects: { title: 'Works / Technical Projects', content: 'Inside the Works module (within Services) you can manage checklists by installation type, signatures, and customer progress.' },
        cash: { title: 'Cash Management', content: 'Open and close cash sessions, perform transfers, and daily reconciliations.' },
        documents: { title: 'Commercial Documents', content: 'Here you manage quotations, fiscal documents, credit notes, and the document flow by location.' },
        stockTransfers: { title: 'Stock Transfers', content: 'Move stock between locations with operational tracking, reasons, and auditable history.' },
        receivables: { title: 'Accounts Receivable', content: 'Track debt, receipts, partial settlements, and customer follow-up from the financial side.' },
        expenses: { title: 'Expense Management', content: 'Register multi-item expenses, follow PGT classification, operational filters, and approval history.' },
        payroll: { title: 'Payroll (HR)', content: 'Track payroll sheets, attendance, mandatory documents, and HR reports without confusing this module with Financial Analysis.' },
        procurement: { title: 'Purchasing and Procurement', content: 'Manage purchase orders, suppliers, approvals, and the connection to pricing.' },
        suppliers: { title: 'Suppliers', content: 'Centralize suppliers, catalogs, activity status, and purchasing context with clearer operational reading.' },
        pricing: { title: 'Pricing and Costs', content: 'Review margins, costs, and suppliers to support commercial and purchasing decisions.' },
        reports: { title: 'Reports', content: 'Consult executive reports, exports, and recurring schedules for operations and control.' },
        feedback: { title: 'Feedback and Support', content: 'Log feedback, follow internal tickets, and share operational improvements with context.' },
        alerts: { title: 'Operational Alerts', content: 'Receive critical stock, operations, and supervision alerts so teams can react quickly.' },
        licenses: { title: 'Licenses', content: 'Review license status, renewals, and the operational documentation tied to digital assets.' },
        users: { title: 'User Management', content: 'Create and manage users directly inside the Administrative Center, with profiles and change trails in the same cockpit.' },
        integrity: { title: 'Integrity Verification', content: 'Anti-fraud module that checks inconsistencies and detects suspicious activities.' },
        settings: { title: 'Settings', content: 'Configure stores, payment methods and accounts, VAT, and the operational parameters that feed the ERP.' },
        templateBuilder: { title: 'Template Builder and Print Setup', content: 'Build templates, snippets, and ready-made banking blocks with visual preview and runtime PDFs.' },
        financial: { title: 'Financial Analysis', content: 'Analyze profits, margins, and store performance with detailed financial indicators.' },
        about: { title: 'Manual, Dossier, and Final Report', content: 'On the About page you can download the User Manual, Technical Dossier, and Go-Live Final Report.' }
      }
    },
    expensesPage: {
      title: 'Expense Management',
      subtitle: '{{count}} expenses',
      newExpense: 'New Expense',
      registerExpense: 'Register Expense'
    },
    pricingPage: {
      title: 'Pricing Management',
      description: 'Suppliers, cost prices, and margin analysis',
      newSupplier: 'New Supplier',
      tabs: { suppliers: 'Suppliers', comparison: 'Comparison', weekly: 'Weekly Report', alerts: 'Margin Alerts' },
      stats: {
        activeSuppliers: 'Active Suppliers',
        marginAlerts: 'Margin Alerts',
        critical: 'Critical (Below Cost)',
        minimumMargin: 'Minimum Margin'
      }
    },
    clientsPage: {
      title: 'Clients',
      description: 'Manage individual and company clients',
      templateExcel: 'Excel Template',
      importExcel: 'Import Excel',
      deactivate: 'Deactivate',
      newClient: 'New Client',
      searchPlaceholder: 'Name, NUIT, phone, email...',
      type: 'Type',
      all: 'All',
      individual: 'Individual',
      company: 'Company',
      showDeleted: 'Show deleted',
      listTitle: 'Client List ({{count}})',
      loading: 'Loading...',
      noClientsFound: 'No clients found'
    },
    suppliersPage: {
      title: 'Suppliers',
      description: 'Supplier relationship, activity states, and catalog control in a top area aligned with Clients and the rest of the ERP.',
      badge: 'Procurement',
      templateExcel: 'Excel Template',
      importExcel: 'Import Excel',
      deactivate: 'Deactivate',
      hideDeleted: 'Hide deleted',
      showDeleted: 'Show deleted',
      newSupplier: 'New Supplier',
      searchPlaceholder: 'Search by name, code or NUIT...',
      listTitle: 'Supplier List',
      listCount: '{{count}} supplier(s) found',
      noSuppliersFound: 'No suppliers found',
      stats: {
        total: 'Total Suppliers',
        totalHelper: 'Loaded records',
        active: 'Active',
        activeHelper: 'Operational suppliers',
        inactive: 'Inactive',
        inactiveHelper: 'Paused or archived',
        lastCode: 'Last Code',
        lastCodeHelper: 'Most recent reference'
      }
    },
    payrollPage: {
      title: 'Payroll (HR)',
      description: 'Payroll processing, confirmation, and payment with clearer reading for HR, finance, and internal supervision.',
      badge: 'HR',
      noAccessTitle: 'No access to Payroll (HR)',
      noAccessDescription: 'You need the payroll.view or payroll.edit permission to open this module.',
      processSalary: 'Process Salary',
      processDialogTitle: 'Process Payroll (HR)',
      processDialogDescription: 'Automatic INSS ({{employeeRate}}%+{{employerRate}}%) and IRPS calculation. Commission: {{commissionRate}}% on sales when the target is reached.',
      selectEmployee: 'Select employee',
      incomplete: 'Incomplete ({{count}}%)',
      completeDossierFirst: 'Complete the employee dossier before processing',
      month: 'Month',
      year: 'Year',
      earnings: 'Earnings',
      baseSalary: 'Base Salary',
      manualCommission: 'Manual Commission',
      automatic: 'Automatic',
      simulate: 'Simulate',
      simulationFor: 'Simulation: {{employee}}',
      periodLabel: 'Period',
      commission: 'Commission',
      bonuses: 'Bonuses',
      allowances: 'Allowances',
      grossSalary: 'Gross Salary',
      totalDeductions: 'Total Deductions',
      netSalary: 'Net Salary',
      employerContributionInfo: 'Employer Contribution (Info)',
      fillAndSimulate: 'Fill in the data and click "Simulate" to see the calculation',
      processing: 'Processing...',
      processPayroll: 'Process Payroll',
      stats: {
        payrolls: 'Payrolls',
        payrollsHelper: 'Current period records',
        drafts: 'Drafts',
        draftsHelper: 'Still pending confirmation',
        confirmed: 'Confirmed',
        confirmedHelper: 'Ready for payment',
        paid: 'Paid',
        paidHelper: 'Processed successfully'
      }
    },
    attachmentUploader: {
      saveBeforeUpload: 'Save the record before adding attachments',
      maxFiles: 'Maximum of {{count}} files allowed',
      fileUploaded: 'File uploaded',
      filesUploaded: '{{count}} file(s) uploaded',
      uploadError: 'Failed to upload file',
      deleted: 'Attachment deleted',
      deleteError: 'Failed to delete attachment',
      uploading: 'Uploading...',
      dropHere: 'Drop files here',
      dragOrClick: 'Drag files or click to select',
      fileHint: 'PDF, JPG, PNG up to {{size}}MB (max. {{count}} files)',
      takePhoto: 'Take photo',
      attachmentsCount: 'Attachments ({{count}})',
      noAttachments: 'No attachments',
      deleteTitle: 'Delete Attachment',
      deleteDescription: 'Are you sure you want to delete “{{file}}”? This action will be recorded in the audit log.',
      reasonOptional: 'Reason (optional)',
      reasonPlaceholder: 'Describe the reason for deletion...'
    },
    // Financial Analysis
    financial: {
      title: 'Financial Analysis',
      subtitle: 'Real profit control, stock rotation and supplier analysis',
      realProfit: 'Real Profit',
      byLocation: 'By Location',
      supplierAnalysis: 'Suppliers',
      stockRotation: 'Stock Rotation',
      totalRevenue: 'Total Revenue',
      totalCosts: 'Total Costs',
      netProfit: 'Net Profit',
      staleStock: 'Stale Stock',
      profitByService: 'Profit by Service Type',
      profitByProduct: 'Profit by Product (Top 10)',
      margin: 'Margin',
      highRotation: 'High Rotation',
      lowRotation: 'Low Rotation',
      stockAlerts: 'Stock Alerts'
    },
    // Risk Management
    risk: {
      title: 'Risk Management',
      subtitle: 'Client control, fraud and financial discipline',
      clientRisk: 'Client Risk',
      fraud: 'Fraud',
      locations: 'Locations',
      audit: 'Audit',
      highRiskClients: 'High Risk Clients',
      blockedClients: 'Blocked Clients',
      totalDebt: 'Total Debt',
      suspiciousActivities: 'Suspicious Activities',
      underperformingLocations: 'Underperforming Locations',
      riskAssessment: 'Client Risk Assessment',
      noRiskClients: 'No clients with risk',
      creditLimit: 'Credit Limit',
      paymentHistory: 'Payment History'
    },
    // Language
    language: {
      title: 'Language',
      portuguese: 'Portuguese',
      english: 'English',
      changed: 'Language changed to {{language}}'
    }
  }
};

export default translations;
